export default {
  "businessTransactions.xPressMode": "简洁模式订单",
  "menu.wallets": "钱包",
  "menu.wallets.balance": "余额",
  "menu.wallets.balance.detail": "余额详情",
  "menu.wallets.balance.deposit": "充值",
  "menu.wallets.balance.exchange": "换汇",
  "menu.wallets.balance.notifications": "通知",
  "menu.wallets.balance.currencyHoliday": "货币假期",
  "menu.wallets.balance.withdrawal": "提现",
  "menu.wallets.globalAccount": "全球收款账户",
  "menu.wallets.globalAccount.globalAccountList": "账户列表",
  "menu.wallets.globalAccount.createGlobalAccount": "创建账户",
  "menu.wallets.globalAccount.createGlobalAccountResult": "创建结果",
  "menu.wallets.globalAccount.globalAccountDetail": "详情",
  "menu.transfers": "转账",
  "menu.transfers.single": "单次转账",
  "menu.transfers.batch": "批量转账",
  "menu.batchTransfers": "批量转账",
  "menu.batchTransfers.personal": "个人汇款转账",
  "menu.batchTransfers.business": "商业汇款转账",
  "menu.batchTransfers.preview": "批量转账预览",
  "menu.globalAccountGuide": "文档中心",
  "menu.batchTransfers.payroll": "企业发薪转账",
  "menu.batchTransfers.global": "全球支付转账",
  "menu.personalTransactions.batch": "待转账列表",
  "menu.personalTransactions.batchTransactionList": "批量转账列表",
  "menu.personalTransactions": "个人汇款交易",
  "menu.personalTransactions.balance": "余额交易",
  "menu.personalTransactions.balanceDetail": "商户订单详情",
  "menu.personalTransactions.transfer": "转账交易",
  "menu.personalTransactions.transferDetail": "订单详情",
  "menu.personalTransactions.orderSearch": "订单搜索",
  "menu.personalTransactions.transferTest": "测试页面",
  "menu.payrollTransactions": "企业发薪",
  "menu.payrollTransactions.transfer": "转账交易",
  "menu.payrollTransactions.batch": "待转账列表",
  "menu.payrollTransactions.batchTransactionList": "批量转账列表",
  "menu.payrollTransactions.transferDetail": "订单详情",
  "menu.businessTransactions.batch": "待转账列表",
  "menu.businessTransactions.batchTransactionList": "批量转账列表",
  "menu.businessTransactions": "商业汇款交易",
  "menu.businessTransactions.balance": "余额交易",
  "menu.businessTransactions.balanceDetail": "商户订单详情",
  "menu.businessTransactions.transfer": "交易列表",
  "menu.businessTransactions.postMaterials": "补充材料列表",
  "businessTransactions.postMaterials.supplemented": "是否已补充",
  "businessTransactions.postMaterials.supplementTime": "补充材料时间",
  "menu.businessTransactions.transferDetail": "订单详情",
  "menu.balanceTransactions.accountTransactionList": "账户交易记录",
  "menu.balanceTransactions": "余额管理",
  "menu.balanceTransactions.balance": "交易记录",
  "menu.balanceTransactions.balanceDetail": "商户订单详情",
  "menu.balanceTransactions.withdrawal": "发起提现",
  "menu.balanceTransactions.withdrawalDetail": "详情",
  "menu.e-commerce-platform": "电商平台",
  "menu.e-commerce-platform.shopManagement": "店铺管理",
  "menu.e-commerce-platform.shopManagement.shopManagementList": "店铺列表",
  "menu.e-commerce-platform.shopManagement.createShop": "创建店铺",
  "menu.e-commerce-platform.shopManagement.editShop": "编辑店铺",
  "menu.e-commerce-platform.shopManagement.shopDetail": "店铺详情",
  "menu.developer": "开发者",
  "menu.developer.xtransfer-payout-api": "xTransfer 代付接口",
  "menu.riskControl.support-docs": "证明材料",
  "menu.myCustomer": "我的客户",
  "menu.myCustomer.cases": "档案管理",
  "menu.myCustomer.personalCase": "档案详情",
  "menu.myCustomer.businessCase": "档案详情",
  "menu.myCustomer.add-personal-customer": "添加客户",
  "menu.myCustomer.add-business-customer": "添加客户",
  "menu.myCustomer.batchUpload": "批量上传",
  "menu.myCustomer.batchUpload.batchRecipientUpload": "客户信息",
  "menu.myCustomer.batchUpload.batchProofMaterialsUpload": "证明材料",
  "menu.riskControl": "风控管理",
  "menu.esign": "在线签名",
  "menu.esign.esign-index": "在线签名",
  "menu.welcome": "欢迎使用",
  "menu.layout": "首页",
  "menu.wallets.balance.balanceEntry": "钱包入口",
  "menu.riskControl.channel-support-docs": "搜索证明材料",
  "menu.riskControl.channel-order-detail": "订单详情",
  "menu.transfers.dispatch": "批量转账",
  "menu.company-management": "公司管理",
  "menu.company-management.info": "公司信息",
  "menu.company-management.add": "添加公司",
  "menu.company-management.base": "添加公司",
  "menu.company-management.nda": "签署保密协议",
  "menu.company-management.due-diligence-form": "尽职调查问卷",
  "menu.company-management.aml-ctf-scp-questionnaire": "反洗钱/反恐怖融资/制裁问卷",
  "menu.company-management.contract-management": "合同管理",
  "menu.members": "成员管理",
  "pages.members.column.email": "邮箱",
  "pages.members.column.role": "角色",
  "pages.members.column.status": "状态",
  "pages.members.column.invitedAt": "邀请时间",
  "pages.members.column.action": "操作",
  "pages.members.status.active": "正常",
  "pages.members.status.disabled": "已禁用",
  "pages.members.status.pending": "待接受邀请",
  "pages.members.status.removed": "已移除",
  "pages.members.role.unassigned": "未分配角色",
  "pages.members.primaryAdmin": "主账号",
  "pages.members.hint.primaryAdminManaged": "如需变更请联系客户经理",
  "pages.members.hint.adminManaged": "如需变更请联系主账号或客户经理",
  "pages.members.hint.rolePermissionsManaged": "角色的权限由平台设定，不能在这里修改。",
  "pages.members.hint.rolesPreset": "角色说明",
  "pages.members.hint.roleSelectionPolicy": "1. 业务角色与管理身份：本列表展示日常业务操作角色。被设为「主账号」的成员固定使用最高权限的运维主管角色；「管理员」为团队管理身份。\n2. 分配规则：每位成员仅可分配一个业务角色。角色由平台统一预设，如需特殊权限定制请联系客户经理。",
  "pages.members.hint.rolesPresetDesc1": "1. 业务角色与管理身份：本列表展示日常业务操作角色。被设为「主账号」的成员固定使用最高权限的运维主管角色；「管理员」为团队管理身份。",
  "pages.members.hint.rolesPresetDesc2": "2. 分配规则：每位成员仅可分配一个业务角色。角色由平台统一预设，如需特殊权限定制请联系客户经理。",
  "pages.members.hint.inviteFlow": "对方会收到一封邀请邮件，点击邮件中的链接自行设置密码后即可登录。在对方接受之前，状态为「待接受邀请」。",
  "pages.members.roleDescription.MERCHANT_FULL_OPERATOR": "可操作钱包、余额、全部订单模块及嵌入式服务柜台；同时可查看客户、风控、电商、公司、开发者和设置模块。",
  "pages.members.roleDescription.MERCHANT_ORDER_FUND_OPERATOR": "负责全流程日常业务经办，支持创建订单、换汇与单笔付款经办；无系统设置与高级配置权限。",
  "pages.members.roleDescription.MERCHANT_ORDER_OPERATOR": "负责转账与批量付款下发、发薪提交及订单管理；仅可查看账户余额，无资金充提与换汇权限。",
  "pages.members.roleDescription.MERCHANT_FUND_OPERATOR": "负责账户资金日常调度，支持充值、提现申请及外汇兑换；仅可查看关联订单，无订单创建与下发权限。",
  "pages.members.roleDescription.MERCHANT_FINANCE_RECONCILIATION": "专用于财务审计与核算，支持查看全币种账户余额、资金流水与对账报表；无任何动账与经办权限。",
  "pages.members.roleDescription.MERCHANT_ORDER_VIEWER": "仅用于业务追踪与排查，支持查询订单状态及导出报表；不可查看账户余额，无任何动账与操作权限。",
  "pages.members.column.roleName": "角色名称",
  "pages.members.column.roleDescription": "角色说明",
  "pages.members.column.permissionCount": "权限数",
  "pages.members.column.permissionCountValue": "权限数：{count}",
  "pages.members.column.assignedMembers": "已分配成员",
  "pages.members.column.module": "模块",
  "pages.members.module.wallet": "钱包（充值/换汇/提现）",
  "pages.members.module.balance": "余额管理",
  "pages.members.module.personalPayout": "个人汇款交易",
  "pages.members.module.businessPayout": "商业汇款交易",
  "pages.members.module.payroll": "企业发薪",
  "pages.members.module.globalPayout": "全球支付",
  "pages.members.module.globalPayin": "全球收款",
  "pages.members.module.embeddedServiceCounter": "嵌入式服务柜台",
  "pages.members.module.myCustomers": "我的客户",
  "pages.members.module.riskControl": "风控管理",
  "pages.members.module.ecommerce": "电商平台",
  "pages.members.module.company": "公司管理",
  "pages.members.module.developer": "开发者",
  "pages.members.module.settings": "设置",
  "pages.members.permission.view": "查看",
  "pages.members.permission.operate": "操作",
  "pages.members.permission.allowed": "有",
  "pages.members.permission.viewAllowed": "有查看权限",
  "pages.members.permission.viewDenied": "无查看权限",
  "pages.members.permission.operateAllowed": "有操作权限",
  "pages.members.permission.operateDenied": "无操作权限",
  "pages.members.permissionCount": "该成员可使用的功能（共 {total} 项，已授予 {granted} 项）",
  "pages.members.filter.allStatuses": "全部状态",
  "pages.members.filter.emailPlaceholder": "按邮箱模糊查询",
  "pages.members.action.search": "查询",
  "pages.members.action.refresh": "刷新",
  "pages.members.action.roleManagement": "角色说明",
  "pages.members.action.sendInvite": "发送邀请",
  "pages.members.action.cancel": "取消",
  "pages.members.action.cancelInvite": "取消邀请",
  "pages.members.action.remove": "移除",
  "pages.members.action.grantAdmin": "设为管理员",
  "pages.members.action.removeAdmin": "取消管理员",
  "pages.members.confirm.cancelInvite": "取消此邀请？",
  "pages.members.confirm.removeTitle": "彻底移除此成员？该操作不可直接恢复。",
  "pages.members.confirm.grantAdmin": "确定将该成员设为管理员？业务角色保持不变。",
  "pages.members.confirm.removeAdmin": "取消该成员的管理员身份？其业务角色保持不变。",
  "pages.members.modal.changeRole": "修改成员角色",
  "pages.members.modal.roleManagement": "角色说明",
  "pages.members.modal.roleDetails": "{role} - 权限详情",
  "pages.members.modal.addMember": "添加成员",
  "pages.members.role.permissionScope": "当前角色的权限范围",
  "pages.members.placeholder.email": "请输入对方的邮箱地址",
  "pages.members.validation.email": "请输入有效邮箱",
  "pages.members.validation.selectRole": "请选择一个角色",
  "pages.members.error.memberStats": "成员统计读取失败",
  "pages.members.error.roles": "角色读取失败",
  "pages.members.error.operation": "操作失败",
  "pages.members.error.roleUpdate": "角色更新失败",
  "pages.members.error.invite": "邀请失败",
  "pages.members.error.invitePendingOtherMerchant": "该账号已有其他商户的待处理邀请，请先处理原邀请后再试。",
  "pages.members.error.resend": "重发失败",
  "pages.members.message.operationSucceeded": "操作成功",
  "pages.members.message.adminGranted": "已设为管理员",
  "pages.members.message.adminRemoved": "已取消管理员身份",
  "pages.members.message.domainWarningSent": "邮箱域名与商户常用域名不同；邀请邮件已发送。",
  "pages.members.message.domainWarningNotSent": "邮箱域名与商户常用域名不同；邀请记录已创建，但邮件未发送。",
  "pages.members.message.inviteMailFailed": "邀请记录已创建，但邮件未发送，请稍后重试",
  "pages.members.message.inviteSent": "邀请邮件已发送",
  "pages.members.message.resendMailFailed": "邀请已更新，但邮件发送失败",
  "pages.members.message.resendSent": "邀请已重新发送",
  "pages.members.domain.title": "邮箱域名提示",
  "pages.members.domain.notSet": "未设置",
  "pages.members.domain.emailSentSuffix": "邀请邮件已发送。",
  "pages.members.domain.warning": "该邮箱域名与商户常用域名不同（{domains}），请确认后再继续。{emailSent}",
  "pages.members.domain.confirmation": "受邀邮箱域名与当前主账号邮箱域名不一致（{domains}）。继续将发送邀请；取消会关闭窗口并清空本次填写内容。",
  "pages.members.domain.continue": "继续",
  "pages.members.domain.terminate": "终止邀请",
  "pages.members.role.admin": "管理员",
  "pages.members.role.operator": "操作员",
  "pages.members.role.viewer": "只读人员",
  "pages.members.action.invite": "邀请成员",
  "pages.members.action.disable": "禁用",
  "pages.members.action.enable": "启用",
  "pages.members.action.changeRole": "修改角色",
  "pages.members.action.resend": "重新发送邀请",
  "pages.members.confirm.disableTitle": "确定要禁用这个成员吗？禁用后对方将无法登录。",
  "pages.members.confirm.enableTitle": "确定要重新启用这个成员吗？",
  "pages.members.message.invited": "邀请已发送",
  "pages.members.message.roleChanged": "角色已更新",
  "pages.members.message.disabled": "已禁用",
  "pages.members.message.enabled": "已启用",
  "pages.members.message.duplicate": "该邮箱已经是本企业成员",
  "pages.members.message.selfDisableError": "不能禁用自己的账号",
  "pages.members.modal.inviteTitle": "邀请新成员",
  "pages.members.form.email.label": "邮箱",
  "pages.members.form.email.placeholder": "请输入对方的邮箱地址",
  "pages.members.form.email.required": "请输入邮箱",
  "pages.members.form.email.invalid": "邮箱格式不正确",
  "pages.members.form.role.label": "角色",
  "pages.members.form.role.required": "请选择角色",
  "pages.members.role.desc.admin": "所有业务模块的查看/创建权限（不含成员管理，那个只认账号本身是不是管理员）",
  "pages.members.role.desc.operator": "可创建转账等操作",
  "pages.members.role.desc.viewer": "仅可查看，不能新增/编辑/提交",
  "pages.members.column.roleTemplate": "角色模板",
  "pages.members.column.permissions": "权限概览",
  "pages.members.role.custom": "自定义",
  "pages.members.role.realAdmin": "管理员",
  "pages.members.action.editPermissions": "编辑权限",
  "pages.members.action.copyTo": "复制权限给…",
  "pages.members.action.applyTemplate": "按模板重置",
  "pages.members.modal.editTitle": "编辑成员权限",
  "pages.members.modal.addTitle": "新增成员",
  "pages.members.modal.copyToTitle": "复制权限给其他成员",
  "pages.members.hint.roleTemplate": "选择角色模板会自动勾选对应权限，勾选之后你可以再手动调整，调整不会影响模板本身",
  "pages.members.hint.copyFrom": "选择一个现有成员，直接复制他当前的权限作为起点",
  "pages.members.catalog.module": "模块",
  "pages.members.catalog.view": "查看",
  "pages.members.catalog.create": "创建",
  "pages.members.catalog.selectAll": "全选",
  "pages.members.catalog.clearAll": "清空",
  "pages.members.message.copied": "权限已复制",
  "pages.members.message.added": "成员已添加",
  "pages.members.message.updated": "权限已更新",
  "pages.members.form.or": "或",
  "pages.members.catalog.currentMatch": "当前权限对应：",
  "pages.members.form.copyFrom.label": "从现有成员复制权限（可选）",
  "pages.members.form.copyFrom.placeholder": "选择一个成员，快速复制其权限",
  "pages.members.copyTo.targetsLabel": "选择要接收这份权限的成员",
  "pages.members.copyTo.empty": "暂无其他成员可复制",
  "menu.global-payout": "全球支付",
  "menu.global-payout.order-list": "交易列表",
  "menu.global-payout.order-detail": "订单详情",
  "menu.global-payout.batch": "待转账列表",
  "menu.global-payout.batchTransactionList": "批量转账列表",
  "menu.global-payout.batch-transfers": "全球支付",
  "menu.global-payin": "PayIn订单",
  "menu.global-payin.order-list": "订单列表",
  "menu.global-payin.order-detail": "订单详情",
  "xch_017841": "订单号",
  "xch_017851": "状态",
  "xch_017861": "汇款用途",
  "xch_017871": "收单通道",
  "xch_017881": "收款金额",
  "xch_017891": "付款金额",
  "xch_017901": "分发金额",
  "xch_017911": "手续费",
  "xch_017921": "手续费币种",
  "xch_017931": "商户手续费",
  "xch_017941": "付款人",
  "xch_017951": "实际付款人",
  "xch_017961": "收款人名称",
  "xch_017971": "创建时间",
  "xch_017981": "更新时间",
  "xch_017991": "操作",
  "xch_018001": "详情",
  "xch_018011": "搜索",
  "xch_018021": "请选择",
  "xch_018031": "基础信息",
  "xch_018041": "交易信息",
  "xch_018831": "收单信息",
  "xch_018061": "材料信息",
  "xch_018071": "收款方信息",
  "xch_018861": "付款方信息",
  "xch_018091": "账户信息",
  "xch_018101": "交易附言",
  "xch_018841": "渠道订单ID",
  "xch_018851": "渠道支付订单号",
  "xch_018131": "订单ID",
  "xch_018141": "账户名称",
  "xch_018151": "账户号",
  "xch_018161": "银行名称",
  "xch_018171": "档案状态",
  "xch_018801": "通过",
  "xch_018191": "实体类型",
  "xch_018811": "企业",
  "xch_018821": "个人",
  "xch_018221": "收款方国家/地区",
  "xch_018231": "姓名",
  "xch_018241": "性别",
  "xch_018251": "证件类型",
  "xch_018261": "证件号码",
  "xch_018271": "签发日期",
  "xch_018281": "证件有效日期",
  "xch_018291": "国籍",
  "xch_018301": "手机号码",
  "xch_018311": "邮箱",
  "xch_018321": "紧急电话",
  "xch_018331": "出生日期",
  "xch_018341": "地址",
  "xch_018871": "付款人与实际付款人关系",
  "xch_018881": "实际付款人证件类型",
  "xch_018891": "实际付款人证件号码",
  "xch_018901": "实际付款人证件签发日期",
  "xch_018911": "实际付款人证件有效日期",
  "xch_018401": "其他补充",
  "xch_018411": "合规备注",
  "xch_018641": "待下发",
  "xch_018651": "入账中",
  "xch_018661": "完成",
  "xch_018671": "失败",
  "xch_018681": "留学缴费",
  "xch_018691": "保险",
  "xch_018701": "租金",
  "xch_018711": "微信",
  "xch_018721": "支付宝",
  "xch_018731": "银行打款",
  "xch_018521": "缴费单",
  "xch_018531": "正式发票（PI）",
  "xch_018541": "身份证正面",
  "xch_018551": "身份证反面",
  "xch_018561": "录取通知书",
  "xch_018571": "其他材料",
  "xch_018741": "身份证",
  "xch_018751": "护照",
  "xch_018761": "驾驶证",
  "xch_018771": "居留证",
  "xch_018781": "工作许可证",
  "xch_018791": "其他",
  "menu.settings": "设置",
  "menu.myCustomer.whitelist": "白名单管理",
  "menu.bankDirectManagement": "嵌入式服务柜台",
  "menu.bankDirectManagement.customerManagement": "客户管理",
  "menu.bankDirectManagement.addCustomer": "添加客户",
  "menu.bankDirectManagement.customerDetail": "客户详情",
  "menu.bankDirectManagement.accountManagement": "账户管理",
  "menu.bankDirectManagement.transactionConfig.feeConfig": "手续费配置",
  "menu.bankDirectManagement.transactionConfig.limitConfig": "限额配置",
  "menu.bankDirectManagement.transactionList": "交易列表",
  "menu.bankDirectManagement.transactionConfig": "费用配置",
  "menu.bankDirectManagement.transactionConfig.exchangeRateConfig": "汇率配置",
  "menu.bankDirectManagement.transactionList.transactionListPage": "交易列表",
  "menu.bankDirectManagement.transactionList.pendingPaymentList": "待收款列表",
  "menu.bankDirectManagement.transactionList.transactionDetail": "订单详情",
  "menu.kyt.transactionDetail": "交易详情",
  "menu.compliance": "合规管理",
  "xch_00001": "监控",
  "xch_00002": "档案",
  "xch_00003": "警报",
  "xch_00004": "仪表板",
  "xch_00005": "分析",
  "xch_00006": "批量筛查",
  "xch_00007": "设置",
  "xch_00008": "eKYC 设置",
  "xch_00009": "筛选设置",
  "xch_00010": "配置可匹配字段",
  "xch_00011": "配置筛选偏好",
  "xch_00012": "账户设置",
  "xch_00013": "报告",
  "xch_00014": "全部",
  "xch_00015": "姓名、电话号码、身份证号码",
  "xch_00016": "档案名称",
  "xch_00017": "国家/地区",
  "xch_00018": "部分",
  "xch_00019": "状态",
  "xch_00020": "操作",
  "xch_00021": "编辑",
  "xch_00022": "下载报告",
  "xch_00023": "{0}/页",
  "xch_00024": "前往",
  "xch_00025": "添加筛选视图",
  "xch_00026": "编辑筛选视图",
  "xch_00027": "创建时间",
  "xch_00028": "档案 ID",
  "xch_00029": "更新时间",
  "xch_00030": "姓名",
  "xch_00031": "性别",
  "xch_00032": "国家",
  "xch_00033": "出生日期",
  "xch_00034": "关系",
  "xch_00035": "上次筛查时间",
  "xch_00036": "关联",
  "xch_00037": "关联信息",
  "xch_00038": "阶段",
  "xch_00039": "开户",
  "xch_00040": "自动筛查",
  "xch_00041": "审查",
  "xch_00042": "通过",
  "xch_00043": "资料",
  "xch_00044": "审查",
  "xch_00045": "评论",
  "xch_00046": "证明详情",
  "xch_00047": "不限",
  "xch_00048": "添加",
  "xch_00049": "删除",
  "xch_00050": "确定",
  "xch_00051": "详情",
  "xch_00052": "保存",
  "xch_00053": "匹配",
  "xch_00054": "警报时间",
  "xch_00055": "类别",
  "xch_00056": "重新开启",
  "xch_00057": "资料",
  "xch_00058": "档案",
  "xch_00059": "钱包",
  "xch_00060": "余额",
  "xch_00061": "转账",
  "xch_00062": "顾客",
  "xch_00063": "交易",
  "xch_00064": "帮助",
  "xch_00065": "xCurrency 实时报价",
  "xch_00066": "通知",
  "xch_00067": "查看更多",
  "xch_00068": "单次转账",
  "xch_00069": "批量转账",
  "xch_00070": "上传转账列表",
  "xch_00071": "确认转账",
  "xch_00072": "支付转账",
  "xch_00073": "上传您的转账文件，或先下载模板并填充转账数据后再上传。",
  "xch_00074": "下载模板",
  "xch_00075": "点击或拖动文件到此区域进行上传",
  "xch_00076": "支持单个上传。请不要上传跟批量转账不相关的文件。",
  "xch_00077": "您的批量转账文件正在上传和解析中，请耐心等待。",
  "xch_00078": "准备您的转账中",
  "xch_00079": "准备中，如果有很多转账，可能需要一点时间。您可以关闭此页面并稍后再回来。",
  "xch_00080": "所有转账均创建成功",
  "xch_00081": "恭喜，所有转账均已成功创建。您可以继续完成付款。",
  "xch_00082": "上传概览",
  "xch_00083": "成功创建的转账",
  "xch_00084": "创建失败的转账",
  "xch_00085": "继续",
  "xch_00086": "取消",
  "xch_00087": "{0}笔转账未能处理",
  "xch_00088": "有{0}笔转账创建失败，您可以选择忽略并继续传输，也可以选择修改和重新上传。",
  "xch_00089": "失败的转账详情",
  "xch_00090": "下载失败的转账",
  "xch_00091": "行数",
  "xch_00092": "商户订单号",
  "xch_00093": "客户名称",
  "xch_00094": "错误信息",
  "xch_00095": "支付",
  "xch_00096": "{0} 笔转账已经可以支付",
  "xch_00097": "恭喜，{0} 笔转账均已成功创建。您可以继续完成付款。",
  "xch_00098": "支付详情",
  "xch_00099": "原币种",
  "xch_00100": "收款币种",
  "xch_00101": "收款币种总金额",
  "xch_00102": "汇率",
  "xch_00103": "付款金额",
  "xch_00104": "手续费",
  "xch_00105": "总计 {0} 付款金额",
  "xch_00106": "付款前余额",
  "xch_00107": "付款后余额",
  "xch_00108": "{0}笔转账成功",
  "xch_00109": "{0}笔转账失败",
  "xch_00110": "重新批量上传",
  "xch_00111": "忽略创建失败的转账并继续",
  "xch_00112": "确认",
  "xch_00113": "确认付款",
  "xch_00114": "单击“确认”后，批量转账将开始处理。",
  "xch_00115": "您的余额不足",
  "xch_00116": "请先充值资金到您的钱包",
  "xch_00117": "您的批量转账正在处理",
  "xch_00118": "这通常需要一些时间，请耐心等待。",
  "xch_00119": "客户的身份证明文件有效期过期，请与客户联系补充新的身份证明文件有效期。",
  "xch_00120": "付款人的国籍与身份证明文件的发行国家问题不符。",
  "xch_00121": "身份证明文件的发行国家必须是付款人的居住国。",
  "xch_00122": "顾客年龄不符合风险控制要求。",
  "xch_00123": "付款人不能是公司。",
  "xch_00124": "付款人进入黑名单，不允许进行交易。",
  "xch_00125": "收款人进入黑名单，不允许进行交易。建议更换其他收款人。",
  "xch_00126": "收款人银行卡信息校验失败。可能是客户银行卡信息填写错误。请联系客户确认银行卡信息（姓名、卡号、证件号等）或更换其他银行卡或收款人后再试。",
  "xch_00127": "收款人银行卡不支持收款，请联系客户更换其他银行卡或收款人后再试。",
  "xch_00128": "收款人转账额度超过限制。建议客户过一段时间后再试。",
  "xch_00129": "收款人银行卡状态异常，不支持收款。请联系客户更换其他银行卡或收款人后再试。",
  "xch_00130": "您只能上传基于模板填充了转账数据的文件",
  "xch_00131": "同一个批次只能上传一个文件",
  "xch_00132": "上传模板文件的版本太旧了，请重新下载并填写转账数据后再次上传。",
  "xch_00133": "批处理转账已经完成，但是以下转账失败了。您可以检查下面所列的失败原因。",
  "xch_00134": "恭喜您，批量转账已经全部完成。",
  "xch_00135": "您有批量转账处于待付款状态，请继续完成付款或取消付款后再上传新批次。",
  "xch_00136": "您有批量转账处于转账处理状态，请耐心等待转账完成再上传新批次。",
  "xch_00137": "开发者",
  "xch_00138": "xTransfer 代付接口",
  "xch_00139": "一键接入 {1}扩展{0}",
  "xch_00140": "您的业务到中国",
  "xch_00141": "7×24 小时即时转账",
  "xch_00142": "市场领先的汇率",
  "xch_00143": "支持中国几乎所有银行",
  "xch_00144": "开始集成",
  "xch_00145": "搜索",
  "xch_00146": "开始日期",
  "xch_00147": "结束日期",
  "xch_00148": "订单或姓名",
  "xch_00149": "重置",
  "xch_00150": "导出",
  "xch_00151": "收款人姓名",
  "xch_00152": "货币对",
  "xch_00153": "汇款金额",
  "xch_00154": "手续费",
  "xch_00155": "汇率",
  "xch_00156": "抱歉，您的转账数量超过了我们支持的最多 {0} 条。请删除一些转账，然后再次上传。",
  "xch_00157": "抱歉，我们没有在您上传的文件中读取到任何转账数据。请您确保上传的文件正确无误后再上传。",
  "xch_00158": "收款金额",
  "xch_00159": "待下发",
  "xch_00160": "成功",
  "xch_00161": "失败",
  "xch_00162": "已取消",
  "xch_00163": "详情",
  "xch_00164": "关键词",
  "xch_00165": "共 {0} 件",
  "xch_00166": "我们于 {0} 更新了新的模板，请先下载新的模板再填充转账数据和上传，我们才能正确解析您的批量转账数据文件。",
  "xch_00167": "订单详情",
  "xch_00168": "模板已更新",
  "xch_00169": "支付金额",
  "xch_00170": "汇率",
  "xch_00171": "付款人信息",
  "xch_00172": "基本信息",
  "xch_00173": "身份信息",
  "xch_00174": "类型",
  "xch_00175": "问题国",
  "xch_00176": "号码",
  "xch_00177": "到期日",
  "xch_00178": "地址",
  "xch_00179": "详细地址",
  "xch_00180": "城市",
  "xch_00181": "地区或州",
  "xch_00182": "邮政编码",
  "xch_00183": "居住国家",
  "xch_00184": "关联",
  "xch_00185": "资金来源",
  "xch_00186": "转账目的",
  "xch_00187": "收款人信息",
  "xch_00188": "银行账号",
  "xch_00189": "身份证",
  "xch_00190": "国家",
  "xch_00191": "州/省",
  "xch_00192": "县府",
  "xch_00193": "国籍",
  "xch_00194": "职业",
  "xch_00195": "有效期",
  "xch_00196": "收款人在银行预留的身份证信息已过期，无法收取该笔资金。建议与客户联系更新身份证信息或更换其他银行卡或收款人后重试。",
  "xch_00197": "收款人身份证号码格式不正确，请与客户联系以确认身份证号码信息或更换其他收款人后再试。",
  "xch_00198": "收款人的银行卡是II或III类个人银行结算帐户，超过每日限额。请与客户联系明天再试，或更换其他银行卡或收款人后再试。注意：II类帐户的每日限额通常为10,000，III类帐户的每日限额为5,000）。",
  "xch_00199": "结汇失败，跨币种转账模式，结算时间为北京时间工作日周一至周五 9:30-16:00，UTC+08:00。",
  "xch_00200": "银行报告您的转账信息格式不正确，转账失败了。请确认此笔转账信息或联系我们以获得帮助。",
  "xch_00201": "该笔转账异常，请联系我们以获得帮助。",
  "xch_00202": "银行报告收款人这笔转账的生日格式不正确。请确认此笔转账的信息或与我们联系以获得帮助。",
  "xch_00203": "银行报告此笔转账的收款人的姓名不匹配。请与客户联系确认信息或更换其他收款人后重试。",
  "xch_00204": "银行报告此笔转账的收款人因在线验证失败而无法收取资金，请与客户联系以确认信息或更改其他收款人后重试。",
  "xch_00205": "余额不足，转账失败。请确认您钱包中的余额或联系我们寻求帮助。",
  "xch_00206": "银行报告此笔转账的付款人的银行账号不能为空。请确认此笔转账的信息或与我们联系以获得帮助。",
  "xch_00207": "银行报告此笔转账的付款人的常住国不能为空。请确认此笔转账的信息或与我们联系以获得帮助。",
  "xch_00208": "暂时无力支付",
  "xch_00209": "因为未能以「跨币种交易模式」（结算时间是工作日星期一至星期五 9：30-16：00，UTC+08：00）执行此批量转账而支付失败。请在结算时间内再尝试发起支付或使用「同币种交易模式」（结算时间是 7x 24 小时）。有任何疑问可以联系我们。",
  "xch_00210": "此笔转账的{0}不能为空。请确认此笔转账信息或与我们联系以寻求帮助。",
  "xch_00211": "收款人的银行卡号不是银联卡号，因此不支持转账。请联系客户更换为银行卡信息或其他收款人后重试。注意：目前暂不支持银行账户（比如：存折账户）",
  "xch_00212": "此笔转账的商户订单号已经存在于历史的转账列表中，请确认信息是否正确。",
  "xch_00213": "「付款金额」和「收款金额」两个必填其一。",
  "xch_00214": "收款人的地址的县或者区无法识别或者填写错误。",
  "xch_00215": "显示设置",
  "xch_00216": "日",
  "xch_00217": "周",
  "xch_00218": "月",
  "xch_00219": "付款人的身份信息需要进一步的人工审查，通常我们很快审查，如果这种状态持续存在，请与我们联系以寻求帮助。",
  "xch_00220": "付款人或收款人的手机号码已被他人绑定，请与我们联系以获得帮助。",
  "xch_00221": "付款人或收款人的身份信息与他人存在重复，需要进一步确认。通常，我们很快审查。如果这种状态持续存在，请与我们联系以寻求帮助。",
  "xch_00222": "您填写的「 {0}」格式不正确。请确认您是按照要求填写。如有任何疑问，您可以查看帮助文档或联系我们以获得帮助。",
  "xch_00223": "抱歉，全部转账都生成失败。",
  "xch_00224": "您可以修改并重新上传。",
  "xch_00225": "只有当您点击「确认付款」后，我们才将为您锁定汇率。",
  "xch_00226": "您填写的「 {0}」的格式不正确，请确认您是按照日期格式要求进行填写。如有疑问可以查看帮助文档或联系我们以获得帮助。",
  "xch_00227": "您填写的「 {0}」的格式不正确，请确认您填写的信息里没有包含数字以外的字符，如有疑问可以查看帮助文档或联系我们以获得帮助。",
  "xch_00228": "您填写的「 {0}」的币种暂不支持，如有疑问可以联系我们以获得帮助。",
  "xch_00229": "您填写的「 {0}」的金额超过最大限制，如有疑问可以联系我们以获得帮助。",
  "xch_00230": "在此模板中，收款人的姓名必须用中文。如果您有任何疑问，可以检查帮助文档或与我们联系以寻求帮助。",
  "xch_00231": "账户余额",
  "xch_00232": "账户信息",
  "xch_00233": "账户名",
  "xch_00234": "公司",
  "xch_00235": "珠海踹桃科技有限公司",
  "xch_00236": "刷新",
  "xch_00237": "当前展示汇率仅供参考，5分钟内有效。请在交易后确认实际汇率。",
  "xch_00238": "工作日下午 6 点 30 分更新",
  "xch_00239": "天前",
  "xch_00240": "天前",
  "xch_00241": "小时前",
  "xch_00242": "小时前",
  "xch_00243": "分钟前",
  "xch_00244": "分钟前",
  "xch_00245": "总金额",
  "xch_00246": "全部转账失败",
  "xch_00247": "您可以检查下面所列的失败原因。",
  "xch_00248": "导出 {0} 个项目",
  "xch_00249": "导出 {0} 个项目",
  "xch_00250": "模板",
  "xch_00251": "自定义数据列",
  "xch_00252": "可用列",
  "xch_00253": "显示列",
  "xch_00254": "支付完成时间",
  "xch_00255": "因为网络波动问题上传失败，请您重新上传一次。",
  "xch_00256": "退出登录",
  "xch_00257": "授权失败，请重新登录",
  "xch_00258": "重新登录",
  "xch_00259": "全部数据列",
  "xch_00260": "查看详情",
  "xch_00261": "付款人的身份证明文件不能是中国居民身份证。",
  "xch_00262": "充值到余额",
  "xch_00263": "确认金额",
  "xch_00264": "跟踪订单",
  "xch_00265": "填写充值信息",
  "xch_00266": "充值金额",
  "xch_00267": "限额",
  "xch_00268": "充值类型",
  "xch_00269": "支持「低成本换汇」",
  "xch_00270": "支持「快速换汇」",
  "xch_00271": "汇率：",
  "xch_00272": "交割时效：",
  "xch_00273": "换汇交易可用时间：",
  "xch_00274": "更优惠的汇率",
  "xch_00275": "即时交割",
  "xch_00276": "工作日",
  "xch_00277": "请通过电汇向以下账户充值",
  "xch_00278": "账户信息",
  "xch_00279": "付款明细",
  "xch_00280": "币种",
  "xch_00281": "银行名称",
  "xch_00282": "SWIFT 代码",
  "xch_00283": "银行地址",
  "xch_00284": "收款人名称",
  "xch_00285": "帐号",
  "xch_00286": "收款人地址",
  "xch_00287": "付款备注",
  "xch_00288": "您充值",
  "xch_00289": "您到账",
  "xch_00290": "到账时间",
  "xch_00291": "{0} 天内",
  "xch_00292": "您创建了充值订单",
  "xch_00293": "按照提示完成充值",
  "xch_00294": "您的资金正在转账到我们银行账户途中",
  "xch_00295": "我们已收到您的{0}",
  "xch_00296": "我们将您的 {0} 添加到您的余额中",
  "xch_00297": "我们还没有付款",
  "xch_00298": "我们已经付款了",
  "xch_00299": "取消充值",
  "xch_00300": "余额交易",
  "xch_00301": "{0} 余额",
  "xch_00302": "换汇",
  "xch_00303": "金额",
  "xch_00304": "换汇金额",
  "xch_00305": "可用余额：",
  "xch_00306": "提交订单",
  "xch_00307": "全选",
  "xch_00308": "低成本模式",
  "xch_00309": "快速模式",
  "xch_00310": "何时换汇",
  "xch_00311": "现在",
  "xch_00312": "在指定的汇率（即将推出）",
  "xch_00313": "在指定的时间（即将推出）",
  "xch_00314": "汇率趋势",
  "xch_00315": "即将推出",
  "xch_00316": "确认订单",
  "xch_00317": "换汇时间概览",
  "xch_00318": "换汇模式",
  "xch_00319": "收款金额",
  "xch_00320": "参考汇率",
  "xch_00321": "换汇后的 {0} 余额",
  "xch_00322": "用户换汇的 {0} 金额",
  "xch_00323": "换汇金额概览",
  "xch_00324": "取消换汇",
  "xch_00325": "处理中",
  "xch_00326": "限额 {0}〜{1} {2}",
  "xch_00327": "可用",
  "xch_00328": "全部",
  "xch_00329": "充值",
  "xch_00330": "换汇",
  "xch_00331": "电汇转账过程中银行及其代理行可能会收取手续费。这取决于您在电汇时候选择的手续费承担方式。更多详细信息可以联系您的开户行进行咨询。充值金额以我们收到的实际金额为准。",
  "xch_00332": "支持低成本换汇",
  "xch_00333": "支持快速换汇",
  "xch_00334": "汇款充值到账速度和汇出行的操作时间以及选择的汇款路径有关，建议您提供汇款路径给到我们客户成功经理以便我们更好为您提供建议来提高充值到账速度。",
  "xch_00335": "成功",
  "xch_00336": "进行中",
  "xch_00337": "订单编号",
  "xch_00338": "交易时间",
  "xch_00339": "金额（{0}）",
  "xch_00340": "订单编号",
  "xch_00341": "筛选",
  "xch_00342": "{0} 余额",
  "xch_00343": "余额详情",
  "xch_00344": "到达时间",
  "xch_00345": "待处理（需要采取行动）",
  "xch_00346": "入职",
  "xch_00347": "筛查",
  "xch_00348": "已确认（审核中）",
  "xch_00349": "已清除",
  "xch_00350": "已确认（风险已降低）",
  "xch_00351": "已确认（无风险）",
  "xch_00352": "已确认（已屏蔽）",
  "xch_00353": "自己",
  "xch_00354": "父母",
  "xch_00355": "配偶",
  "xch_00356": "子女",
  "xch_00357": "兄弟姐妹",
  "xch_00358": "祖父母",
  "xch_00359": "孙辈",
  "xch_00360": "姓名、电话号码、身份证号码",
  "xch_00361": "档案详情",
  "xch_00362": "男",
  "xch_00363": "相关警报",
  "xch_00364": "协会信息",
  "xch_00365": "上传",
  "xch_00366": "历史",
  "xch_00367": "姓",
  "xch_00368": "名",
  "xch_00369": "姓氏（拼音）",
  "xch_00370": "名字（拼音）",
  "xch_00371": "街道",
  "xch_00372": "详细地址",
  "xch_00373": "邮政编码",
  "xch_00374": "证件号码",
  "xch_00375": "确认兑换？您的订单将立即交换。",
  "xch_00376": "汇率已发生变化",
  "xch_00377": "由于国际外汇市场实时波动，汇率已发生变化。请重新确认汇率报价。",
  "xch_00378": "失效日期",
  "xch_00379": "签发日期",
  "xch_00380": "查看证书",
  "xch_00381": "您创建了一个换汇订单",
  "xch_00382": "等待满足换汇条件",
  "xch_00383": "我们已交换您的{0}",
  "xch_00384": "我们将您的 {0} 添加到您的余额中",
  "xch_00385": "交易汇率",
  "xch_00386": "相关交易",
  "xch_00387": "我们已经全面升级为同币种（CNY）交易模式，支持7×24小时即时转账。批量转账前，请先将外币兑换至人民币钱包。如果您有任何疑问，可以联系我们的客户成功经理。",
  "xch_00388": "知道了",
  "xch_00389": "余额交易",
  "xch_00390": "转账交易",
  "xch_00391": "通知",
  "xch_00392": "取消此{0}订单？",
  "xch_00393": "此{0}订单将不会处理，您可以稍后再次发起。",
  "xch_00394": "确认取消",
  "xch_00395": "不用了",
  "xch_00396": "我们收到您的{0}",
  "xch_00397": "请将{0}转账至我们提供的银行账户以完成存款。",
  "xch_00398": "您的银行可能需要一些时间才能将款项转交给我们。款项到达后，我们会通知您。",
  "xch_00399": "我们将您的 {0} 添加到您的余额中",
  "xch_00400": "我们已将您的 {0} 添加到您的余额中",
  "xch_00401": "您取消了订单",
  "xch_00402": "您已完成存款",
  "xch_00403": "交易汇率",
  "xch_00404": "当前暂不可换汇",
  "xch_00405": "{0} 时可以换汇，请在这个时间段内重试。",
  "xch_00406": "取消订单",
  "xch_00407": "不",
  "xch_00408": "{0}是必填项",
  "xch_00409": "充值后的 {0} 余额",
  "xch_00410": "没有更多了",
  "xch_00411": "即时",
  "xch_00412": "通知列表",
  "xch_00413": "我们正在交换您的{0}",
  "xch_00414": "新的",
  "xch_00415": "已添加此汇率",
  "xch_00416": "请选择",
  "xch_00417": "低成本模式",
  "xch_00418": "您创建了一个批量调拨单",
  "xch_00419": "您的转账指令已发出，等待付款。",
  "xch_00420": "您已支付转账订单",
  "xch_00421": "批次转移已完成",
  "xch_00422": "您的批量传输正在处理中",
  "xch_00423": "所有转账均未处理成功",
  "xch_00424": "我们处理您的批量传输",
  "xch_00425": "等待兑换条件满足",
  "xch_00426": "交换条件已满足",
  "xch_00427": "根据境内银行和监管要求，您需要在后台提供付款人证件和亲属关系证明，如果您有任何疑问，可以联系我们的客户经理。",
  "xch_00428": "根据境内银行和监管要求，您需要在后台提供付款人的证件和收入证明，如果您有任何疑问，可以联系我们的客户经理。",
  "xch_00429": "已拒绝",
  "xch_00430": "更改密码",
  "xch_00431": "收款人的银行卡超过每日限额。请与客户联系明天再试，或更换其他银行卡或收款人后再试。",
  "xch_00432": "付款人或收款人的身份验证失败。请确认您提交的身份信息或证明材料是否正确。如有任何疑问，请联系我们的客户经理。",
  "xch_00433": "待下发",
  "xch_00434": "待审核",
  "xch_00435": "待补充材料",
  "xch_00436": "是否立即下发?",
  "xch_00437": "交易材料",
  "xch_00438": "根据合作银行的反洗钱要求，以确保不断使用我们的服务 请在48小时内提交收款人",
  "xch_00439": "和付款人",
  "xch_00440": "的证明。",
  "xch_00441": "关系证明",
  "xch_00442": "收款人是付款人的",
  "xch_00443": "附录材料",
  "xch_00444": "请选择要认证的证件类型",
  "xch_00445": "付款人证件",
  "xch_00446": "结婚证书",
  "xch_00447": "亲属关系承诺函",
  "xch_00448": "户口本",
  "xch_00449": "赡养公证书",
  "xch_00450": "出生证明",
  "xch_00451": "雇佣合同",
  "xch_00452": "收入证明",
  "xch_00453": "在职证明",
  "xch_00454": "工资流水",
  "xch_00455": "纳税证明",
  "xch_00456": "兄弟姐妹",
  "xch_00457": "子孙女、外子孙女",
  "xch_00458": "风控管理",
  "xch_00459": "证明材料",
  "xch_00460": "失败",
  "xch_00461": "商户订单号或证件号或名字",
  "xch_00462": "付款人",
  "xch_00463": "付款人证件号码",
  "xch_00464": "收款人",
  "xch_00465": "请上传",
  "xch_00466": "模板",
  "xch_00467": "例如如下",
  "xch_00468": "交易不处于待下发状态，不能下发",
  "xch_00469": "下发失败",
  "xch_00470": "收款人证件号码",
  "xch_00471": "材料审核中",
  "xch_00472": "关系不能为其他人，如需补充材料，请联系客户经理",
  "xch_00473": "在线签名",
  "xch_00474": "提交前请签名。",
  "xch_00475": "在线签名",
  "xch_00476": "待完善",
  "xch_00477": "待提交",
  "xch_00478": "链接已失效，请联系客服重新获取",
  "xch_00479": "刷新亲属承诺函的状态",
  "xch_00480": "刷新",
  "xch_00481": "XC模式",
  "xch_00482": "欢迎使用",
  "xch_00483": "首页",
  "xch_00484": "钱包入口",
  "xch_00485": "搜索证明材料",
  "xch_00486": "商户订单详情",
  "xch_00487": "支持「XC换汇」",
  "xch_00488": "客户管理",
  "xch_00489": "客户名单",
  "xch_00490": "汇率配置",
  "xch_00491": "订单管理",
  "xch_00492": "充值订单",
  "xch_00493": "换汇订单",
  "xch_00494": "基金管理",
  "xch_00495": "资金池总览",
  "xch_00496": "客户余额",
  "xch_00497": "客户列表入口",
  "xch_00498": "余额详情",
  "xch_00499": "支持XC换汇",
  "xch_00500": "选择模式",
  "xch_00501": "购买XCNH",
  "xch_00502": "余额管理",
  "xch_00503": "钱包管理",
  "xch_00504": "订单详情",
  "xch_00505": "选择模板",
  "xch_00506": "上传文件，或选择模板下载，然后开始制作。",
  "xch_00507": "选择模板",
  "xch_00508": "选择模板下载",
  "xch_00509": "我们支持多种文件模板，方便您进行批量传输。请选择最适合您的模板。",
  "xch_00510": "如果您知道收款人的银行账户信息，您可以直接将款项转入他们的银行账户。",
  "xch_00511": "收款人收款信息：",
  "xch_00512": "收款人全名（中文）",
  "xch_00513": "收款人性别",
  "xch_00514": "收款人国籍",
  "xch_00515": "收款人职业",
  "xch_00516": "收款人邮政编码",
  "xch_00517": "收款人省份",
  "xch_00518": "收款人城市",
  "xch_00519": "付款地府或地区",
  "xch_00520": "收款人详细地址",
  "xch_00521": "收款人电话号码",
  "xch_00522": "收款人身份证号码",
  "xch_00523": "身份证有效期始",
  "xch_00524": "身份证有效期末",
  "xch_00525": "收款人银行账号",
  "xch_00526": "如果你知道收款人的银行详细信息，就可以直接将钱转入他们的银行账户。",
  "xch_00527": "收款人全名（中文）",
  "xch_00528": "下载",
  "xch_00529": "去交易",
  "xch_00531": "费用:  {0}  / 每笔",
  "xch_00533": "切换模式",
  "xch_00534": "选择模式",
  "xch_00535": "经典模式",
  "xch_00536": "简洁模式",
  "xch_00537": " ",
  "xch_00538": "网络错误，请稍后刷新重试",
  "xch_00539": "支持经典模式转账",
  "xch_00540": "支持简洁模式转账",
  "xch_00541": "返回余额页面",
  "xch_00542": "交易模式",
  "xch_00543": "已创建",
  "xch_00544": "待入账",
  "xch_00545": "已完成",
  "xch_00546": "已入账",
  "xch_00547": "已取消",
  "xch_00548": "已换汇",
  "xch_00549": "客户资金池总览",
  "xch_00550": "系统后备资金不足，正在准备中，请稍后",
  "xch_00551": "交易速度较快，但汇率不是最佳的",
  "xch_00552": "汇率较佳，但是交易速度不是最快的",
  "xch_00553": "交易速度和汇率都是最佳的",
  "xch_00554": "消息管理",
  "xch_00555": "消息列表",
  "xch_00556": "数据分析",
  "xch_00557": "币种分析",
  "xch_00558": "交易分析",
  "xch_00559": "汇款情况",
  "xch_00560": "到账时长",
  "xch_00561": "欢迎",
  "xch_00562": "客户余额",
  "xch_00563": "交易模式解释",
  "xch_00564": "客户名称",
  "xch_00565": "充值币种",
  "xch_00566": "交易币种",
  "xch_00567": "未配置汇率",
  "xch_00568": "邮箱",
  "xch_00569": "账户状态",
  "xch_00570": "操作",
  "xch_00571": "编辑",
  "xch_00572": "汇款记录",
  "xch_00573": "请输入客户姓名",
  "xch_00574": "请输入 {0}",
  "xch_00575": "商户号",
  "xch_00576": "商户编码",
  "xch_00577": "请选择 {0}",
  "xch_00578": "备注",
  "xch_00579": "进度",
  "xch_00580": "可能需要 {0} 秒",
  "xch_00581": "操作成功",
  "xch_00582": "操作失败",
  "xch_00583": "操作",
  "xch_00584": "汇款记录",
  "xch_00585": "原始货币",
  "xch_00586": "目标货币",
  "xch_00587": "基准汇率源",
  "xch_00588": "报价汇率",
  "xch_00589": "目标货币兑换量",
  "xch_00590": "汇兑差额",
  "xch_00591": "基准汇率",
  "xch_00592": "启用状态",
  "xch_00593": "创建",
  "xch_00594": "汇率报价",
  "xch_00595": "姓名",
  "xch_00596": "汇差 %",
  "xch_00598": "货币",
  "xch_00599": "客户",
  "xch_00601": "只查询订单数量",
  "xch_00602": "只查询交易量",
  "xch_00603": "查询订单数量和交易量",
  "xch_00604": "天",
  "xch_00605": "星期",
  "xch_00606": "月",
  "xch_00607": "年",
  "xch_00608": "交易汇总分析",
  "xch_00609": "总交易额",
  "xch_00610": "日期",
  "xch_00611": "订单数量",
  "xch_00612": "订单金额",
  "xch_00613": "入账金额",
  "xch_00614": "转账凭证",
  "xch_00615": "入账",
  "xch_00616": "实际入账金额",
  "xch_00617": "如何分配",
  "xch_00618": "完成",
  "xch_00619": "调拨中",
  "xch_00620": "支持经典模式下发",
  "xch_00621": "支持简洁模式下发",
  "xch_00622": "工作台",
  "xch_00623": "转账中",
  "xch_00624": "未获取汇率，请联系您的客户经理",
  "xch_00625": "您有一笔尚未处理的订单，请及时处理！",
  "xch_00626": "申请 XC",
  "xch_00627": "订单总数",
  "xch_00628": "转账完成数",
  "xch_00629": "进度",
  "xch_00630": "批量转账列表",
  "xch_00631": "关闭",
  "xch_00632": "批次号",
  "xch_00633": "系统维护中，暂时无法完成自主交易，请联系您的客户经理进行兑换交易",
  "xch_00634": "取消选择",
  "xch_00635": "批量取消",
  "xch_00636": "您确定要取消所选订单吗？",
  "xch_00637": "不再提醒",
  "xch_00638": "转账完成",
  "xch_00639": "添加过滤视图",
  "xch_00640": "编辑过滤视图",
  "xch_00641": "删除筛选视图",
  "xch_00642": "添加客户",
  "xch_00643": "客户ID",
  "xch_00644": "企业类型",
  "xch_00645": "提升额度",
  "xch_00646": "查看",
  "xch_00647": "英文姓氏",
  "xch_00648": "姓氏",
  "xch_00649": "英文名",
  "xch_00650": "名",
  "xch_00651": "出生日期",
  "xch_00652": "证件号码",
  "xch_00653": "证件过期时间",
  "xch_00654": "女",
  "xch_00655": "背面",
  "xch_00656": "正面",
  "xch_00657": "侧面",
  "xch_00658": "确认（审查）",
  "xch_00659": "打开（需要行动）",
  "xch_00660": "确认（低风险）",
  "xch_00661": "拒绝",
  "xch_00662": "已拒绝的类型",
  "xch_00663": "风险原因",
  "xch_00664": "视图名字",
  "xch_00665": "此项为必填项",
  "xch_00666": "业务地区",
  "xch_00667": "删除标签页",
  "xch_00668": "您确定要删除此选项卡吗？",
  "xch_00669": "预览",
  "xch_00670": "审查通过",
  "xch_00671": "审查中",
  "xch_00672": "资金证明材料",
  "xch_00673": "关系证明材料",
  "xch_00674": "选择要提交的证明材料",
  "xch_00675": "应包含雇员姓名、工作单位、收入、工作期限等基本雇佣信息，并加盖雇主印章",
  "xch_00676": "表格应包含基本的雇佣信息，例如员工姓名、雇主、收入和雇佣期限。",
  "xch_00677": "上传公司提供的收入证明。",
  "xch_00678": "公司提供的在职证明",
  "xch_00679": "上传公司提供的在职证明。",
  "xch_00680": "它应包含基本的雇佣信息，例如员工姓名、雇主和雇佣期限。",
  "xch_00681": "应包含雇主或工资支付附言以及雇员姓名",
  "xch_00682": "最近的工资收入银行对账单",
  "xch_00683": "上传近期工资收入银行对账单",
  "xch_00684": "应包含员工姓名、过去一年应税收入总额等基本信息",
  "xch_00685": "纳税证明",
  "xch_00686": "上传纳税证明",
  "xch_00687": "请提供与收款人的亲属关系承诺函，以确保不断使用我们的服务。",
  "xch_00688": "请提供您的户口本信息，以确保持续使用我们的服务。",
  "xch_00689": "请提供赡养公证书作为证明，以确保持续使用我们的服务。",
  "xch_00690": "请提供您的结婚证信息，以便我们继续为您提供服务。",
  "xch_00691": "请提供收款亲属的出生证明，以确保继续使用我们的服务。",
  "xch_00692": "后退",
  "xch_00693": "请检查是否填写完整",
  "xch_00694": "上传证件并填写信息",
  "xch_00695": "获取档案过滤器视图数据失败",
  "xch_00696": "删除失败,无此记录,请刷新",
  "xch_00697": "姓名重复，请使用其他姓名重新提交。",
  "xch_00698": "保存筛选视图失败",
  "xch_00699": "银行卡号",
  "xch_00700": "道琼斯验证",
  "xch_00701": "同意并继续",
  "xch_00702": "您的个人信息将被加密并存储",
  "xch_00703": "快捷身份认证",
  "xch_00704": "并提升额度",
  "xch_00705": "我们很乐意帮助您的客户提升汇款限额。我们需要进一步\n的证明材料，以便您的客户能够将更多资金汇回家中",
  "xch_00706": "上传并识别 {0} 作为身份证明",
  "xch_00707": "身份证或护照",
  "xch_00708": "补充 {0} 等个人资料",
  "xch_00709": "职业和住址",
  "xch_00710": "全名",
  "xch_00711": "身份证明详情",
  "xch_00712": "收集日期",
  "xch_00713": "材料",
  "xch_00714": "待转账列表",
  "xch_00715": "批量转账列表",
  "xch_00716": "我的客户",
  "xch_00717": "档案管理",
  "xch_00718": "档案详情",
  "xch_00719": "添加客户",
  "xch_00720": "支持「商业汇款换汇」",
  "xch_00721": "货贸模式",
  "xch_00722": "支持商业汇款转账",
  "xch_00723": "交易场景",
  "xch_00724": "个人汇款",
  "xch_00725": "商业汇款",
  "xch_00726": "商业汇款",
  "xch_00727": "尽请期待",
  "xch_00728": "个人汇款转账",
  "xch_00729": "商业汇款转账",
  "xch_00730": "个人汇款交易",
  "xch_00731": "商业汇款交易",
  "xch_00732": "付款企业名称",
  "xch_00733": "款项性质",
  "xch_00734": "收款企业名称",
  "xch_00735": "实际收款账户名称",
  "xch_00736": "补充材料",
  "xch_00737": "应包括交易双方的姓名和地址、名称、材料、数量、型号、单价、总价、交易日期、交易双方的签名或印章、交易订单号、发票号及其他信息。",
  "xch_00738": "PI/PO",
  "xch_00739": "上传形式发票/采购订单",
  "xch_00740": "订单号",
  "xch_00741": "订单证明材料",
  "xch_00742": "上传文件",
  "xch_00743": "确认信息",
  "xch_00744": "创建订单",
  "xch_00745": "准备创建 {0} 笔订单",
  "xch_00746": "恭喜，所有订单均已成功验证。您可以继续完成订单。",
  "xch_00747": "恭喜，{0} 笔订单已成功校验。您可以继续创建订单。",
  "xch_00748": "点击“确认”后，订单即被创建。",
  "xch_00749": "确认订单创建",
  "xch_00750": "所有订单均创建成功",
  "xch_00751": "恭喜！所有订单均已成功创建，您可以继续完成付款。",
  "xch_00752": "前往补充材料",
  "xch_00753": "上传概览",
  "xch_00754": "成功校验的订单",
  "xch_00755": "校验失败的订单",
  "xch_00756": "交易列表",
  "xch_00757": "交易信息",
  "xch_00758": "物流单号",
  "xch_00759": "物流公司",
  "xch_00760": "材料信息",
  "xch_00761": "交易合同",
  "xch_00762": "企业中文名",
  "xch_00763": "收款账户名称",
  "xch_00764": "收款银行账户",
  "xch_00765": "收款银行开户行",
  "xch_00766": "企业名称",
  "xch_00767": "企业付款账号",
  "xch_00768": "最多可上传 8 个文件",
  "xch_00769": "预付款",
  "xch_00770": "全款",
  "xch_00771": "尾款",
  "xch_00772": "其他",
  "xch_00773": "您填写的「Payee Bank Name」为空或者不规范，请您提供详细的收款银行开户行后重新提交订单。\n",
  "xch_00774": "您填写的「Payee Bank Account Name（Chinese）」收款账户名称与收款企业名称不一致，当选择公司收款时，账户名需要与公司名保持一致。",
  "xch_00775": "合规审核",
  "xch_00776": "待转账",
  "xch_00777": "收款方信息",
  "xch_00778": "付款方信息",
  "xch_00779": "驳回",
  "xch_00780": "请在上传前提交材料。",
  "xch_00781": "支持个人汇款转账",
  "xch_00782": "订单搜索",
  "xch_00783": "支付通道代码",
  "xch_00784": "智能路由详情",
  "xch_00785": "时间",
  "xch_00786": "事件",
  "xch_00787": "备注",
  "xch_00788": "{0} 下发成功",
  "xch_00789": "收到代付请求",
  "xch_00790": "尝试通过{0}下发",
  "xch_00791": "请求{0}下发，等待响应",
  "xch_00792": "{0}下发失败",
  "xch_00793": "根据路由规则，选择{0}作为首选渠道",
  "xch_00794": "历史流",
  "xch_00795": "链上历史流",
  "xch_00796": "资本流动信息流绑定",
  "xch_00797": "链上记录",
  "xch_00798": "延期下发",
  "xch_00799": "由于支付通道繁忙,您的支付请求将稍作延期处理。我们会在资金到位后尽快为您下发,请耐心等待。如有疑问,请联系客户经理。",
  "xch_00800": "根据合作银行的反洗钱要求，为了保证我们服务的持续使用，请在48小时内提交收款人{0}的身份证照片。",
  "xch_00801": "上传中国居民身份证",
  "xch_00802": "人像面",
  "xch_00803": "国徽面",
  "xch_00804": "注意：请不要使用卡套或涂改液遮挡证件",
  "xch_00805": "方向错误",
  "xch_00806": "拍摄不全",
  "xch_00807": "反光强烈",
  "xch_00808": "模糊不清",
  "xch_00809": "根据银行监管要求，此订单需要银行人工审核，请稍候片刻，如有任何疑问，请联系您的客户经理。",
  "xch_00810": "身份证明",
  "xch_00811": "交易证明",
  "xch_00812": "点击查看补充材料",
  "xch_00813": "由于地方法规要求需要提供收款人身份证信息，以确保您的汇款安全。",
  "xch_00814": "根据境内银行和监管要求，您需要在后台提供交易证明材料，以确保您的汇款安全。",
  "xch_00815": "根据国内银行和监管部门的要求，您需要提供收款人最新身份证正反面照片作为背景。如有任何疑问，请联系我们的客户经理。",
  "xch_00816": "上传交易凭证",
  "xch_00817": "签署 NDA 文件",
  "xch_00818": "马上签署",
  "xch_00819": "提交公司资料",
  "xch_00820": "前往提交",
  "xch_00821": "完成问卷调查",
  "xch_00822": "请填写",
  "xch_00823": "未能获取信息",
  "xch_00824": "👏🏻 欢迎，{0}",
  "xch_00825": "解锁所有功能还剩 {0} 个步骤",
  "xch_00826": "此外，还需要完成以下{0}个步骤：",
  "xch_00827": "公司管理",
  "xch_00828": "公司信息",
  "xch_00829": "添加公司",
  "xch_00830": "公司注册地",
  "xch_00831": "公司名称",
  "xch_00832": "公司网站",
  "xch_00833": "公司所属行业",
  "xch_00834": "基本信息",
  "xch_00835": "公司注册证明文件",
  "xch_00836": "股权架构图",
  "xch_00837": "最终受益人身份文件",
  "xch_00838": "实际控制人身份信息",
  "xch_00839": "持牌证明文件",
  "xch_00840": "调查问卷1",
  "xch_00841": "调查问卷2",
  "xch_00842": "调查问卷3",
  "xch_00843": "NDA 文件",
  "xch_00844": "上一步",
  "xch_00845": "下一步",
  "xch_00846": "填写公司基本信息",
  "xch_00847": "解锁极简货币批量代付平台全部功能",
  "xch_00848": "感谢选择我们成为您中国境内下发合作伙伴，为了更顺利解锁批量代付平台功能，请提供一些基本信息让我们快速了解您。",
  "xch_00849": "签署保密协议",
  "xch_00850": "公司详细资料",
  "xch_00851": "签署完成后，我们会准备 200 CNY 试用资金",
  "xch_00852": "CNY 试用资金可以用于中国境内下发，可做小额资金下发验证。",
  "xch_00853": "查看试用教程",
  "xch_00854": "在线签署",
  "xch_00855": "去签署",
  "xch_00856": "NDA文件预览",
  "xch_00857": "平台使用教程",
  "xch_00858": "调查问卷",
  "xch_00859": "通过问卷调查，我们可以更深入地了解您。",
  "xch_00860": "根据合规政策要求，我们需要通过调查文件全方位了解您",
  "xch_00861": "线上填写",
  "xch_00862": "填写 Board Resolution Account opening 问卷",
  "xch_00863": "填写 Due Deligence Form 问卷",
  "xch_00864": "填写 AML/CTF/SCP Questionaire 问卷",
  "xch_00865": "线下填写",
  "xch_00866": "下载 Board Resolution Account opening 问卷",
  "xch_00867": "下载  Due Deligence Form 问卷",
  "xch_00868": "下载  AML/CTF/SCP Questionaire Form 问卷",
  "xch_00869": "正式发票（PI）",
  "xch_00870": "用于上传正式发票（Proforma Invoice），包括交易双方名称、地址，名称、材质、数量、型号、单价、总价、交易日期、交易双方签名或者盖章、交易订单号、发票号等信息。",
  "xch_00871": "采购订单（PO）",
  "xch_00872": "用于上传采购订单（Purchase Order），包含交易双方名称、地址，产品名称、材质、数量、型号、单价、总价、交易日期、交易双方签名或盖章、交易订单号等信息。",
  "xch_00873": "物流凭证",
  "xch_00874": "用于上传物流凭证，包括货物运输单据、提单、运单等物流相关文件，确保物流过程的追踪和验证。",
  "xch_00875": "出口报关单",
  "xch_00876": "用于上传出口报关单，包含详细的出口商品信息、报关日期、报关单号、报关双方信息等，以满足出口合规要求。",
  "xch_00877": "沟通记录",
  "xch_00878": "用于上传交易双方的沟通记录，包括电子邮件、聊天记录、电话记录等，以作为交易过程的参考和证据。",
  "xch_00879": "收款人身份证证件",
  "xch_00880": "用于上传收款人的身份证证件，包括护照、身份证等，以验证收款人的身份信息。",
  "xch_00881": "收款人的授权书",
  "xch_00882": "用于上传收款人的授权书，包含授权人签名或盖章，授权内容等，以证明收款人具有合法授权。",
  "xch_00883": "交易双方往期单据",
  "xch_00884": "用于上传交易双方以往的交易单据，作为历史交易记录的参考和验证。",
  "xch_00885": "上下游采购订单证明",
  "xch_00886": "用于上传上下游采购订单证明，确保供应链的完整性和交易的真实性。",
  "xch_00887": "其他材料",
  "xch_00888": "用于上传其他相关材料，以补充和完善交易文件。",
  "xch_00889": "提交",
  "xch_00890": "提交成功",
  "xch_00891": "您的材料尚未提交。您确定要退出吗？",
  "xch_00892": "您的材料提交不完整，请确保至少提交正式发票（PI）或采购订单（PO）中的一种。",
  "xch_00893": "保存成功",
  "xch_00894": "材料审核失败，请重新提交。",
  "xch_00895": "重新提交",
  "xch_00896": "填写基本信息",
  "xch_00897": "邀请他人填写",
  "xch_00898": "付款证明",
  "xch_00899": "未能获取免费配额",
  "xch_00900": "Free Limit",
  "xch_00901": "XC Quota",
  "xch_00902": "今日使用详情",
  "xch_00903": "当您有储备金时，您可以免费使用 xc汇款服务，如有任何疑问，请与您的客户经理联系。",
  "xch_00904": "此订单金额已超过限额。如有任何疑问，请联系我们的客服经理。",
  "xch_00905": "原币种模式",
  "xch_00906": "支持原币种模式汇款",
  "xch_00907": "支持「原币种汇款模式」",
  "xch_00908": "我们的原币汇款模式可简化交易流程，避免汇率波动带来的不确定性，并确保您清楚了解汇款金额。资金无需经过货币转换程序，从而加快了处理速度，是管理多种货币的企业的理想之选。",
  "xch_00909": "您有未处理的转账信息，是否继续进行操作？",
  "xch_00910": "请修正转账信息",
  "xch_00911": "待处理的转账信息：{0}",
  "xch_00912": "上一个",
  "xch_00913": "下一个",
  "xch_00914": "继续转账",
  "xch_00915": "下载更正后的文件",
  "xch_00916": "收款人姓名格式错误",
  "xch_00917": "收款人身份证号码格式错误",
  "xch_00918": "收款人的电话号码不能为空。",
  "xch_00919": "收款人的电话号码格式不正确。",
  "xch_00920": "必须提供此信息",
  "xch_00921": "金额格式错误",
  "xch_00922": "国家代码格式不正确\n\n国籍可以用两位字母代码或三位字母代码填写，例如 SGP\n\nISO 3166-1 alpha-3 或 alpha-2\n\n例如：SGP 或 SG",
  "xch_00923": "性别格式不正确, 请确保为 Male 或 Female 其中的一种\n",
  "xch_00924": "日期格式不正确, 请确保格式为：\n1.YYYY-MM-DD\n2.YYYYMMDD\n3.YYYY/MM/DD",
  "xch_00925": "日期格式不正确, 请确保为\n1.YYYY-MM-DD\n2.YYYYMMDD\n3.YYYY/MM/DD\n其中的一种\n并且不可大于当前日期",
  "xch_00926": "资金来源格式不正确, 请确保为\n1.Employment income\n2.Business Income\n3.Part-time income\n4.Saving deposits\n其中的一种",
  "xch_00927": "付款人证件类型格式不正确, 请确保为\n1.idcard\n2.passport\n3.driver\n4.residence\n5.workpermit\n6.other\n其中的一种",
  "xch_00928": "付款人和收款人关系格式不正确, 请确保为\n1.Self\n2.Spouse\n3.Parent\n4.Children\n5.Sibling\n6.Grandparent\n7.Grandchildren\n其中的一种",
  "xch_00929": "汇款目的格式不正确, 请确保为\n1.FamilySupport\n2.Salary\n其中的一种",
  "xch_00930": "收款人货币格式错误，请确保货币为人民币 (CNY)。",
  "xch_00931": "收款人国籍格式不正确, 请确保为\n1.CHN\n2.CN\n其中的一种",
  "xch_00932": "支付货币格式错误",
  "xch_00933": "订单号已存在",
  "xch_00934": "当前进度",
  "xch_00935": "银行/数字银行",
  "xch_00936": "支付公司",
  "xch_00937": "汇款公司",
  "xch_00938": "其他机构（请填写）",
  "xch_00939": "公司行业（补充）",
  "xch_00940": "请仔细阅读并{0}相关信息，并在文档末尾{1}填写您的个​​人信息。",
  "xch_00941": "填写",
  "xch_00942": "展开全文",
  "xch_00943": "已完成，下一步",
  "xch_00944": "已清分",
  "xch_00945": "已退款",
  "xch_00946": "您确定要取消订单吗？",
  "xch_00947": "您确定要退款吗？",
  "xch_00948": "退款",
  "xch_00949": "营业执照",
  "xch_00950": "公司年度报告",
  "xch_00951": "公司章程",
  "xch_00952": "公司办公场地照片",
  "xch_00953": "反洗钱/反恐融资政策",
  "xch_00954": "独立第三方风险评估报告",
  "xch_00955": "反洗钱主任/合规官的个人简历",
  "xch_00956": "开立账户董事会决议",
  "xch_00957": "公司详细文件",
  "xch_00958": "公司受益人文件",
  "xch_00959": "合规相关文件",
  "xch_00960": "正在处理，预期耗时 {0} 秒",
  "xch_00961": "文件审核失败，请重新提交。",
  "xch_00962": "感谢选择极简货币的人民币清结算系统为您提供服务。根据持牌金融机构间合作的合规性要求，需要您根据以下几步的指引提供更多信息，让我们快速了解贵公司的基本情况。",
  "xch_00963": "请输入公司名称",
  "xch_00964": "根据金融机构合规性要求，我们需要收集一些关于贵公司的详细信息，用于评估贵公司的业务情况和资质，确保符合金融监管的要求。所有信息将严格保密并妥善存放。",
  "xch_00965": "发生错误，请稍后重试。",
  "xch_00966": "提交成功！",
  "xch_00967": "请点击跳转至待办内容或资料进行查看和填写。如有任何疑问，请随时联系您的客户经理。",
  "xch_00968": "欢迎回来",
  "xch_00969": "您还剩下 {0} 个步骤需要完成",
  "xch_00970": "请跳转至未完成步骤继续填写/上传",
  "xch_00971": "继续填写/上传",
  "xch_00972": "我们建议您按照以下清单准备相关文件。这将大大节省您的时间。",
  "xch_00973": "1.详细的公司文件",
  "xch_00974": "营业执照（如有）、公司年度报表（如有）、公司章程、公司办公场所照片",
  "xch_00975": "2.公司受益人文件",
  "xch_00976": "股权结构图（必须由董事或其代表签字）最终受益所有人的身份证明文件（持有25%以上股权的最终受益所有人的护照照片及有效地址证明）实际控制人的身份信息（如果没有持有25%以上股权的最终受益所有人，则需提供对公司享有最终控制权的自然人的护照照片及有效地址证明）",
  "xch_00977": "3.合规相关文件",
  "xch_00978": "营业执照（当地监管机构颁发的金融支付许可证或营业执照）反洗钱/反恐融资政策（请提供最新版本）独立第三方风险评估报告（如有，请提供最新版本）反洗钱负责人/合规负责人简历开户董事会决议反洗钱/反恐融资/制裁问卷（待填写）尽职调查表（待填写）",
  "xch_00979": "点击填写在线签字人信息",
  "xch_00980": "可以邀请其他授权人员签字。",
  "xch_00981": "保存失败，您编辑的内容已过时，请检查内容并重新保存。",
  "xch_00982": "补充",
  "xch_00983": "（请仔细阅读并{0}相关信息，并在文档末尾在线{1}签署您的个人信息）：",
  "xch_00984": "保存并提交预审",
  "xch_00985": "缺少必填字段",
  "xch_00986": "必须由董事或代表签署",
  "xch_00987": "持有超过25%股份的最终受益人的护照照片和有效地址证明。",
  "xch_00988": "如果没有最终受益人持有超过25%的股份，请提供公司最终控制人的护照照片和有效地址证明。",
  "xch_00989": "由当地监管机构颁发的金融支付许可证或营业执照",
  "xch_00990": "请提供最新版本",
  "xch_00991": "如有，请提供最新版本",
  "xch_00992": "您可以使用公司决议，或 {0} 进行填写和确认。",
  "xch_00993": "我已准备好，立即申请",
  "xch_00994": "下载模板",
  "xch_00995": "欢迎您",
  "xch_00996": "恭喜您已经成功注册并登录极简货币交易管理系统。在正式使用前，按照国际间对于持牌金融机构的合规性要求，您需要在随后的工作流中完成客户准入流程。",
  "xch_00997": "每个步骤都会清楚地指示需要上传或填写的位置。",
  "xch_00998": "请准备以下电子文档，格式包括 JPG、PDF、DOC 等。",
  "xch_00999": "内容在{0}自动保存到云端",
  "xch_01000": "填写问卷",
  "xch_01001": "您的填写率未达标，确定提交吗？高填写率能提高审核成功率！",
  "xch_01002": "确认提交",
  "xch_01003": "如有",
  "xch_01004": "包含公司名称或品牌名称的现场办公室照片",
  "xch_01005": "股权结构图（必须由董事或代表签署）、最终受益人的身份证明文件（持有25%以上股份的最终受益人的护照照片和有效地址证明）、以及实际控制人的身份信息（如果没有持有25%以上股份的最终受益人，则提供公司实际控制人的护照照片和有效地址证明）。",
  "xch_01006": "请提供最新版本",
  "xch_01007": "如果您持有25%或以上的股份，请提供最新版本。",
  "xch_01008": "反洗钱/反恐怖融资/制裁问卷",
  "xch_01009": "尽职调查问卷",
  "xch_01010": "需填写",
  "xch_01011": "我们建议您在开始之前，根据以下清单准备好相关文件。这将大大节省您的时间。如果您在过程中遇到任何问题，请随时联系您的客户经理。",
  "xch_01012": "审查进度",
  "xch_01013": "审核完成",
  "xch_01014": "审核中",
  "xch_01015": "已拒绝",
  "xch_01016": "邀请失败，请重新邀请或联系您的专属客户经理。",
  "xch_01017": "请填写相关信息并签署",
  "xch_01018": "请输入您的姓名！",
  "xch_01019": "请输入您的邮箱地址！",
  "xch_01020": "待签署",
  "xch_01021": "待发起签署",
  "xch_01022": "去填写",
  "xch_01023": "您已填写并签署",
  "xch_01024": "等待签署完成",
  "xch_01025": "填写签署人信息",
  "xch_01026": "为确保合作过程中的信息安全，保护双方的合法权益，并确保合作顺利进行，双方需要签署保密协议。",
  "xch_01027": "根据金融机构合规要求，我们需要通过问卷调查了解贵公司在业务合规和反洗钱/反恐融资方面的实践和详细信息。这确保贵公司符合金融法规，也是我们向贵公司提供服务的必要条件。所有信息将严格保密并安全存储。",
  "xch_01028": "股权结构图（必须由董事或其代表签字）",
  "xch_01029": "最终受益人身份证明文件（持有超过25%股份的最终受益人的护照照片和有效地址证明）",
  "xch_01030": "实际控制人身份信息（如果没有最终受益人持有公司25%以上的股份，请提供公司最终控制人的护照照片和有效地址证明）",
  "xch_01031": "许可证证明（由当地监管机构颁发的金融支付许可证或营业执照）",
  "xch_01032": "反洗钱/反恐融资政策（请提供最新版本）",
  "xch_01033": "独立第三方风险评估报告（如有，请提供最新版本）",
  "xch_01034": "反洗钱专员/合规专员简历",
  "xch_01035": "董事会决议开设账户",
  "xch_01036": "反洗钱/反恐融资/制裁问卷（需填写）",
  "xch_01037": "尽职调查表（待填写）",
  "xch_01038": "请仔细阅读并{0}相关内容，填写完成后请{1}预审，预审通过后请由授权人进行在线签署。",
  "xch_01039": "保存并提交预审",
  "xch_01040": "发生错误，请刷新页面重试。",
  "xch_01041": "签名失败，请联系您的客户经理。",
  "xch_01042": "您已签署",
  "xch_01043": "问卷附件",
  "xch_01044": "上传辅助性说明文件（例如：业务流程图）",
  "xch_01045": "问卷待您填写并提交，以便进行初步审核。",
  "xch_01046": "您的问卷正在初步审核中",
  "xch_01047": "问卷已初步审核完毕，等待您的签字确认。",
  "xch_01048": "立即签署",
  "xch_01049": "顶部",
  "xch_01050": "底部",
  "xch_01051": "预审核不通过，原因: {0}",
  "xch_01052": "请上传图片格式（JPEG、PNG 等）或 PDF 格式的文件。",
  "xch_01053": "全球支付",
  "xch_01054": "订单列表",
  "xch_01055": "批量上传",
  "xch_01056": "支持单次上传。请勿上传与批量添加收款人信息无关的文件。",
  "xch_01057": "错误的客户类型",
  "xch_01058": "邮件格式错误",
  "xch_01059": "请更正案件信息",
  "xch_01060": "继续上传",
  "xch_01061": "收款方",
  "xch_01062": "付款方",
  "xch_01063": "个人",
  "xch_01064": "实体",
  "xch_01065": "选择客户类型",
  "xch_01066": "个人资料记录基本个人信息、联系方式和银行账户数据，确保汇款过程安全准确。",
  "xch_01067": "公司简介记录公司详细信息，包括基本信息、注册信息、银行账户和授权文件，以确保合法合规的汇款。",
  "xch_01068": "银行账号",
  "xch_01069": "成立日期",
  "xch_01070": "企业注册地",
  "xch_01071": "公司邮箱",
  "xch_01072": "电话号码",
  "xch_01073": "请选择档案类型",
  "xch_01074": "地址信息",
  "xch_01075": "客户类型",
  "xch_01076": "由于境内银行监管要求，请重新前往 Classic下单，我们会根据订单特性帮您路由至最优路径下发, 资金钱包无需操作调整。\n",
  "xch_01077": "我们建议您在开始之前准备好以下列出的相应文件，这将大大节省您的时间。如果您在过程中遇到任何问题，请随时联系您的客户经理。",
  "xch_01078": "成功创建的档案",
  "xch_01079": "上传的档案文件",
  "xch_01080": "抱歉，全部档案都创建失败。",
  "xch_01081": "失败的档案详情",
  "xch_01082": "下载失败的表格",
  "xch_01083": "{0}个档案未能处理",
  "xch_01084": "有{0}个档案创建失败，您可以选择根据错误信息检查并进行调整后重新上传。",
  "xch_01085": "所有档案均创建成功",
  "xch_01086": "恭喜，所有档案均已成功创建。你可以前往查看【档案管理】页面进行查看。",
  "xch_01087": "业务性质",
  "xch_01088": "请输入行业详细名称",
  "xch_01089": "受益人信息不完整，请补充相关信息。",
  "xch_01090": "CNY 模式",
  "xch_01091": "跨币种模式",
  "xch_01092": "原币种模式",
  "xch_01093": "暂不考虑",
  "xch_01094": "缺少材料信息",
  "xch_01095": "详细住所（Addressline1）和邮编（Post Code）必须提供其中的一种",
  "xch_01096": "材料类型",
  "xch_01097": "输入订单号，查询多个以空格进行分隔",
  "xch_01098": "{0}笔转账异常",
  "xch_01099": "全部转账异常",
  "xch_01100": "批处理转账已完成，但以下转账仍处于处理中或存在异常。请查看下方列出的原因",
  "xch_01101": "异常转运详情",
  "xch_01102": "此订单正在银行处理中。请前往订单详情页面查看订单状态。如有任何疑问，请联系您的客户经理。",
  "xch_01103": " {0}笔转账中",
  "xch_01104": "上传辅助材料",
  "xch_01105": "上传客户信息",
  "xch_01106": "客户信息",
  "xch_01107": "证明材料",
  "xch_01108": "上传成功的文件",
  "xch_01109": "上传结果",
  "xch_01110": "提交完成",
  "xch_01111": "您的这批辅助材料正在上传和处理中，请稍候。",
  "xch_01112": "您的资料正在上传。",
  "xch_01113": "正在准备。如果材料较多，可能需要一些时间。您可以关闭此页面，稍后再返回。",
  "xch_01114": "提交成功的材料",
  "xch_01116": "文件夹名称",
  "xch_01117": "客户名称",
  "xch_01118": "点击查看上传指南。",
  "xch_01119": "已补充",
  "xch_01120": "未补充",
  "xch_01121": "该证明材料未关联到订单",
  "xch_01122": "信息",
  "xch_01123": "上传您的文件（zip 格式），其中应包含证明材料。",
  "xch_01124": "支持单次上传。请勿上传与批量添加辅助材料信息无关的文件。",
  "xch_01125": "请上传格式类型为 ZIP 的文件，其中应包含证明材料。",
  "xch_01126": "提交失败的材料",
  "xch_01127": "导出失败的证明材料信息",
  "xch_01128": "导出成功",
  "xch_01129": "当款项性质为不为预付款（DepositPayment）时，需要提供物流公司；多个物流公司时，请使用 | 分隔。",
  "xch_01130": "当款项性质不为预付款（DepositPayment）时，需要提供物流单号；多个物流单号时，请使用 | 分隔。",
  "xch_01131": "请提供完整的工商登记企业中文名称。",
  "xch_01132": "该信息必填：如果收款账户类型为企业，户名需与收款企业名称保持一致；如果收款账户类型为个人，请填写个人收款银行账户名称。",
  "xch_01133": "当收款人账户类型为与收款人同名的企业账户时，必须提供银行分支机构详细信息，并指定子分支机构。",
  "xch_01134": "当收款人账户类型为个人账户时，必须提供收款人的中国大陆身份证件。",
  "xch_01135": "款项性质格式不正确，请确保为下列选项中的一种：\n1.DepositPayment\n2.FullPayment\n3.FinalPayment\n4.Other",
  "xch_01136": "此订单已超过3天未更新。发起转账时需要二次确认。如果订单在15天内仍未更新，系统将自动取消该订单。",
  "xch_01137": "此订单已创建超过3天。您是否要继续转账？",
  "xch_01138": "以下订单已创建超过3天。您是否确认继续进行转账？",
  "xch_01139": "提交营业执照时，需包含公司名称、注册地址、注册号、注册日期、法定代表人、经营范围和公司印章。该文件用于核实企业的合法性。",
  "xch_01140": "营业执照",
  "xch_01141": "SWIFT代码",
  "xch_01142": "确认下发",
  "xch_01143": "预审核确认中",
  "xch_01144": "预审核上传中",
  "xch_01145": "上传文件",
  "xch_01146": "点击转账",
  "xch_01147": "批量转账预览",
  "xch_01148": "继续上传新订单",
  "xch_01149": "开启轮训",
  "xch_01150": "停止投票",
  "xch_01151": "上次更新时间",
  "xch_01152": "网络速度慢，请检查您的网络连接。",
  "xch_01153": "文件过大，请考虑将内容拆分成较小的文件。",
  "xch_01154": "上传错误，请重试。",
  "xch_01155": "重新上传",
  "xch_01156": "合同管理",
  "xch_01157": "公共假期期间，自助兑换暂时无法使用。如需兑换，可联系客服协助处理。",
  "xch_01158": "企业注册号",
  "xch_01159": "详细地址",
  "xch_01160": "企业详情",
  "xch_01161": "帐户名称",
  "xch_01162": "银行账户",
  "xch_01163": "银行开户行",
  "xch_01164": "路由类型",
  "xch_01165": "路由值",
  "xch_01166": "企业材料信息",
  "xch_01167": "企业法人",
  "xch_01168": "企业名称",
  "xch_01169": "企业联系邮箱",
  "xch_01170": "注册地址",
  "xch_01171": "企业成立日期",
  "xch_01172": "企业经营期限",
  "xch_01173": "注册资本",
  "xch_01174": "企业经营范围",
  "xch_01175": "企业经营状态",
  "xch_01176": "企业名录等级",
  "xch_01177": "营业执照",
  "xch_01178": "股东材料",
  "xch_01179": "股东身份归属地",
  "xch_01180": "股东姓名",
  "xch_01181": "法人证件号码",
  "xch_01182": "证件有效期",
  "xch_01183": "电话号码",
  "xch_01184": "黑名单筛选",
  "xch_01185": "身份证地址",
  "xch_01186": "钱包模式",
  "xch_01187": "如果您希望通过支付宝/微信收款",
  "xch_01188": "收款人姓名（拼音）",
  "xch_01189": "收款人身份证号码",
  "xch_01190": "收款人：支付宝/微信ID",
  "xch_01191": "请联系您的客户经理寻求帮助，可以切换到其他支付渠道。",
  "xch_01192": "收款账号",
  "xch_01193": "当前筛选条件下未找到订单。",
  "xch_01194": "付款人和收款人关系格式不正确, 请确保为\n1.Self\n2.Spouse\n3.Parent\n4.Children\n5.Sibling\n6.Relative\n7.commercial intercourse\n其中的一种",
  "xch_01195": "上传交易证明材料",
  "xch_01196": "员工",
  "xch_01197": "汇款用途",
  "xch_01198": "查询编号",
  "xch_01199": "付款单",
  "xch_01200": "身份证正面",
  "xch_01201": "身份证背面",
  "xch_01202": "入学通知",
  "xch_01203": "帐户名称",
  "xch_01204": "收款银行名称",
  "xch_01205": "证件类型",
  "xch_01206": "请选择交易场景",
  "xch_01207": "薪酬/赡家",
  "xch_01208": "企业发薪",
  "xch_01209": "货物贸易",
  "xch_01210": "服务贸易",
  "xch_01211": "学费",
  "xch_01212": "企业注册证明文件",
  "xch_01213": "请上传营业执照文件",
  "xch_01214": "留学缴费",
  "xch_01215": "薪酬",
  "xch_01216": "赡家",
  "xch_01217": "实际汇款目的",
  "xch_01218": "香港签证身份文件",
  "xch_01219": "驾照",
  "xch_01220": "免许证",
  "xch_01221": "内地旅行证（香港/澳门）",
  "xch_01222": "健康保险卡",
  "xch_01223": "身份证",
  "xch_01224": "香港临时身份证",
  "xch_01225": "个人通知卡",
  "xch_01226": "大陆入境许可（单次）",
  "xch_01227": "临时文件",
  "xch_01228": "护照",
  "xch_01229": "个人番号卡",
  "xch_01230": "居留许可",
  "xch_01231": "居留卡",
  "xch_01232": "居民证明",
  "xch_01233": "自拍",
  "xch_01234": "香港/澳门至内地通行证",
  "xch_01235": "签证",
  "xch_01236": "关联人员",
  "xch_01237": "收款人身份证明",
  "xch_01238": "付款人身份证明",
  "xch_01239": "交易金额",
  "xch_01240": "交易笔数",
  "xch_01241": "学分等级",
  "xch_01242": "请将必填材料补充完整",
  "xch_01243": "提升信用等级",
  "xch_01244": "身份证明材料",
  "xch_01245": "关系验证材料",
  "xch_01246": "资金证明材料",
  "xch_01247": "点击查看",
  "xch_01248": "付款人身份证件",
  "xch_01249": "收款人身份证件",
  "xch_01250": "白名单管理",
  "xch_01251": "C2C 薪酬",
  "xch_01252": "薪酬（同名汇款）",
  "xch_01253": "赡家（异名汇款）",
  "xch_01254": "雇佣双方签章版劳务合同",
  "xch_01255": "付款人和收款人的身份证明文件",
  "xch_01256": "付款人收入证明（工资单、纳税证明、银行存款证明等）",
  "xch_01257": "付款人和收款人的身份证明文件",
  "xch_01258": "付款人和收款人之间的亲属关系证明或经公证的关系证明（结婚证、户口簿、赡养费公证、出生证明等）",
  "xch_01259": "月限制笔数",
  "xch_01260": "查看资料",
  "xch_01261": "年限制额度",
  "xch_01262": "名称",
  "xch_01263": "已保存",
  "xch_01264": "选择一项进行补充",
  "xch_01265": "标准",
  "xch_01266": "高级",
  "xch_01267": "优秀",
  "xch_01268": "请提供收款人身份证正反面的清晰照片，确保信息完整，包括姓名、身份证号码、出生日期、有效期限等。",
  "xch_01269": "请提供付款人身份证正反面的清晰照片，需确保信息真实、完整，并与付款账户持有人身份一致。",
  "xch_01270": "请提供户口本中包含家庭成员信息的页面照片，包括首页和个人详细页，确保信息清晰无误。",
  "xch_01271": "请提供合法有效的赡养公证书照片，需明确赡养义务人与被赡养人的关系及相关赡养约定。",
  "xch_01272": "请提供结婚证的清晰照片，需确保证件内容完整，包括婚姻登记日期、双方姓名及证件编号。",
  "xch_01273": "请提供子女出生证明的清晰照片，需包括婴儿姓名、出生日期、父母姓名及相关医院签章信息。",
  "xch_01274": "最多可上传 8 张图片。",
  "xch_01275": "当前年限制额度",
  "xch_01276": "当前月限制笔数",
  "xch_01277": "当前信用等级",
  "xch_01278": "提升等级",
  "xch_01279": "提升后年限制金额",
  "xch_01280": "提升后月限制笔数",
  "xch_01281": "收款人与付款人的关系为{0}",
  "xch_01282": "需要提供{0}材料",
  "xch_01283": "下载付款凭证",
  "xch_01284": "货物贸易",
  "xch_01285": "升级",
  "xch_01286": "存在处理中的提升记录",
  "xch_01287": "已是最高等级",
  "xch_01288": "点击或拖拽文件到此区域进行上传。",
  "xch_01289": "请勿上传与徽标图片无关的任何内容",
  "xch_01290": "状态说明",
  "xch_01291": "描述",
  "xch_01292": "待商家完成上传认证材料。",
  "xch_01293": "待转账。只有在此状态下才能转账。",
  "xch_01294": "由于材料不全，订单需要重新提交。",
  "xch_01295": "提交成功，由xCurency Hubs 团队进行处理",
  "xch_01296": "汇款进行中",
  "xch_01297": "汇款指令已执行，但汇款到账用户账户仍需银行最终处理。",
  "xch_01298": "汇款已完成。用户已收到款项。",
  "xch_01299": "转账失败，跨币种交易模式将退款",
  "xch_01300": "发件人合规信息未获批准或出于风险控制等原因。",
  "xch_01301": "付款已取消",
  "xch_01302": "款项已退还",
  "xch_01303": "名称不能为空。",
  "xch_01304": "受益人姓名不能包含非中文字符，也不能为空。",
  "xch_01305": "自定义",
  "xch_01306": "默认",
  "xch_01307": "明亮的",
  "xch_01308": "交易量分析",
  "xch_01309": "客户资金概览",
  "xch_01310": "当天",
  "xch_01311": "本周",
  "xch_01312": "本月",
  "xch_01313": "数据检索失败",
  "xch_01314": "数据检索出错，请联系管理员",
  "xch_01315": "近七天",
  "xch_01316": "四周前",
  "xch_01317": "客户数据总览",
  "xch_01318": "数据采集​​时间",
  "xch_01319": "本月交易量",
  "xch_01320": "一万元",
  "xch_01321": "每日交易量",
  "xch_01322": "今日活跃交易客户",
  "xch_01323": "交易量趋势",
  "xch_01324": "活跃交易客户情况",
  "xch_01325": "服务贸易证明材料",
  "xch_01326": "请上传与具体服务交易场景相关的证明文件，例如发票、合同、交易订单截图或发货单据。请确保包含关键信息，例如双方详细信息、金额、日期等，以便于审核。",
  "xch_01327": "换汇金额超限，请联系你的专属客户经理！",
  "xch_01328": "钱包余额内换汇",
  "xch_01329": "信用额度内换汇",
  "xch_01330": "如何兑换",
  "xch_01331": "假期",
  "xch_01332": "当前货币的外汇交易配置不存在。请联系您的客户经理！",
  "xch_01333": "当前货币的汇率信息尚未配置。请联系您的客户经理。",
  "xch_01334": "货币假期，不支持兑换。",
  "xch_01335": "货币假期",
  "xch_01336": "企业员工证明文件",
  "xch_01337": "请提供企业员工证明文件",
  "xch_01338": "企业材料",
  "xch_01339": "个人薪酬/赡家款",
  "xch_01340": "企业发薪",
  "xch_01341": "货物贸易",
  "xch_01342": "服务贸易",
  "xch_01343": "留学汇款",
  "xch_01344": "其他",
  "xch_01345": "选择产品",
  "xch_01346": "请问您计划使用极简货币何种产品？",
  "xch_01347": "请选择极简货币相应的产品帮助我们为您提供更加贴心的服务，可多选。",
  "xch_01348": "是否持有金融牌照",
  "xch_01349": "企业官方网站",
  "xch_01350": "请输入有效的网址",
  "xch_01351": "业务文件",
  "xch_01352": "个人薪酬 - 工资单/税单",
  "xch_01353": "提交样例证明材料 * 1",
  "xch_01354": "货物贸易 - PI",
  "xch_01355": "货物贸易 - 物流单",
  "xch_01356": "服务贸易 - 相关合同",
  "xch_01357": "企业发薪 - 员工合同",
  "xch_01358": "企业发薪 - 员工名单",
  "xch_01359": "提交聘用合同任选 2 份",
  "xch_01360": "个人赡家款 - 关系证明材料",
  "xch_01361": "业务开展国家/地区",
  "xch_01362": "产品",
  "xch_01363": "感谢您的注册！我们的团队将尽快完成后台审核，并会有专业人员与您联系。审核通过后，您将享有完整的访问权限。感谢您的耐心等待。如有任何疑问，请随时联系我们",
  "xch_01364": "国籍/注册地",
  "xch_01365": "法人身份证正面",
  "xch_01366": "用于上传法人身份证正面信息，包括姓名、照片、身份证号码及其他个人信息，以进行身份​​验证。",
  "xch_01367": "法人身份证背面",
  "xch_01368": "用于上传法人身份证背面信息，包括签发机关、有效期等官方信息，以进行身份​​验证。",
  "xch_01369": "账户管理",
  "xch_01370": "手续费配置",
  "xch_01371": "待收款列表",
  "xch_01372": "新增{0}",
  "xch_01373": "编辑{0}",
  "xch_01374": "删除",
  "xch_01375": "查询",
  "xch_01376": "重置",
  "xch_01377": "汇率配置",
  "xch_01378": "详情",
  "xch_01379": "操作",
  "xch_01380": "创建{0}",
  "xch_01381": "更新",
  "xch_01382": "保存",
  "xch_01383": "提交",
  "xch_01384": "取消",
  "xch_01385": "确认",
  "xch_01386": "返回",
  "xch_01387": "启用",
  "xch_01388": "禁用",
  "xch_01389": "启用状态",
  "xch_01390": "审核通过",
  "xch_01391": "审核失败",
  "xch_01392": "确认（无风险）",
  "xch_01393": "嵌入式服务柜台",
  "xch_01394": "账户配置",
  "xch_01395": "请输入关键词进行搜索",
  "xch_01396": "企业所属行业",
  "xch_01397": "主体类型",
  "xch_01398": "审核中",
  "xch_01399": "待处理",
  "xch_01400": "企业官网",
  "xch_01401": "上传文件",
  "xch_01402": "公司董事",
  "xch_01403": "公司英文名称",
  "xch_01404": "确认收款",
  "xch_01405": "待确认收款",
  "xch_01406": "待汇款方付款",
  "xch_01407": "汇款方付款",
  "xch_01408": "商业场景",
  "xch_01409": "企业注册唯一编号",
  "xch_01410": "年均交易量（预测）",
  "xch_01411": "主要客户分布",
  "xch_01412": "企业注册证书",
  "xch_01413": "主任基本信息",
  "xch_01414": "国家身份总监",
  "xch_01415": "计算方式",
  "xch_01416": "费用金额",
  "xch_01417": "费用比例",
  "xch_01418": "费用比例应在0-1之间",
  "xch_01419": "请以小数形式输入比率，例如：",
  "xch_01420": "0.01 表示收取 1% 的费用",
  "xch_01421": "0.005 表示收取 0.5% 的费用",
  "xch_01422": "固定金额",
  "xch_01423": "动态计算",
  "xch_01424": "企业联系电话",
  "xch_01425": "企业注册号码",
  "xch_01426": "企业营业执照",
  "xch_01427": "下一步",
  "xch_01429": "卖出币种",
  "xch_01430": "卖出金额",
  "xch_01431": "买入币种",
  "xch_01432": "买入金额",
  "xch_01433": "汇款方信息",
  "xch_01434": "手续费金额",
  "xch_01435": "汇款企业",
  "xch_01436": "收款企业",
  "xch_01437": "请选择或创建",
  "xch_01438": "收款方式",
  "xch_01439": "手续费币种",
  "xch_01440": "创建交易",
  "xch_01441": "交易类型",
  "xch_01442": "股东姓名",
  "xch_01443": "证件材料",
  "xch_01444": "未上传",
  "xch_01445": "{0} 个文件",
  "xch_01446": "收款类型",
  "xch_01447": "对公收款",
  "xch_01448": "股东收款",
  "xch_01449": "个人收款",
  "xch_01450": "加载中...",
  "xch_01451": "商品数量",
  "xch_01452": "商品类别",
  "xch_01453": "商品名称",
  "xch_01454": "成本汇率",
  "xch_01455": "交易日期",
  "xch_01456": "交易编号",
  "xch_01457": "公司注册日期",
  "xch_01459": "所在国",
  "xch_01460": "公司注册号",
  "xch_01461": "年均交易额（美元）",
  "xch_01462": "企业客户分布地区",
  "xch_01463": "董事名称",
  "xch_01464": "董事所属国籍",
  "xch_01465": "董事证件号码",
  "xch_01466": "董事手机号码",
  "xch_01467": "董事邮箱",
  "xch_01468": "董事地址",
  "xch_01469": "企业董事信息",
  "xch_01470": "收款银行联行号",
  "xch_01471": "极简合规审核",
  "xch_01472": "入网",
  "xch_01473": "提交材料",
  "xch_01474": "请提供详细的拒绝理由。",
  "xch_01475": "初审",
  "xch_01476": "确认拒绝",
  "xch_01477": "复审",
  "xch_01478": "交易信息",
  "xch_01479": "更新成功",
  "xch_01480": "获取收款企业失败",
  "xch_01481": "交易已成功创建",
  "xch_01482": "创建失败，请重试。",
  "xch_01483": "创建交易失败",
  "xch_01484": "获取汇款企业失败",
  "xch_01485": "编辑企业资料",
  "xch_01486": "更新失败",
  "xch_01487": "汇率牌价",
  "xch_01488": "汇率源",
  "xch_01489": "基准点数",
  "xch_01490": "请输入小数。例如，0.5 表示 50%。",
  "xch_01491": "是否锁汇",
  "xch_01492": "住宅地址",
  "xch_01493": "证件上传",
  "xch_01494": "股东持股比例总和不能超过100%",
  "xch_01495": "股东持股比例不能少于25%",
  "xch_01496": "股东信息",
  "xch_01497": "删除股东",
  "xch_01498": "添加股东",
  "xch_01499": "股东 {0}",
  "xch_01500": "持股比例（%）",
  "xch_01501": "请输入持股比例",
  "xch_01502": "持股比例不得低于25%。",
  "xch_01503": "持股比例不得超过100%。",
  "xch_01504": "身份证件",
  "xch_01505": "股东基本信息",
  "xch_01506": "请检查是否填写完整",
  "xch_01507": "暂无股东信息",
  "xch_01508": "编辑成功",
  "xch_01509": "编辑失败",
  "xch_01510": "股东",
  "xch_01511": "请输入一个整数",
  "xch_01513": "分发",
  "xch_01514": "付款币种",
  "xch_01515": "现汇买入",
  "xch_01516": "现钞买入",
  "xch_01517": "现汇卖出",
  "xch_01518": "现钞卖出",
  "xch_01519": "中间价",
  "xch_01520": "确认删除此汇率配置？",
  "xch_01521": "确认删除配置？",
  "xch_01522": "确认 {0} 配置？",
  "xch_01523": "收款银行账户名",
  "xch_01524": "账户配置",
  "xch_01525": "收款银行账户号",
  "xch_01526": "最小金额",
  "xch_01527": "最大金额",
  "xch_01528": "金额范围",
  "xch_01529": "获取账户配置详情失败",
  "xch_01530": "获取账户配置列表失败",
  "xch_01531": "已补充材料",
  "xch_01532": "是否确认将订单标记为已收款?",
  "xch_01533": "提现",
  "xch_01534": "提现交易",
  "xch_01535": "账号",
  "xch_01536": "下载凭证",
  "xch_01537": "获取详情失败",
  "xch_01538": "交易ID不存在",
  "xch_01539": "凭证下载成功",
  "xch_01540": "下载凭证失败",
  "xch_01541": "获取账户详情失败",
  "xch_01542": "获取账户详情失败，请重试",
  "xch_01543": "上传失败",
  "xch_01544": "文件上传失败，请重试",
  "xch_01545": "无法预览该文件",
  "xch_01546": "添加收款账户",
  "xch_01547": "确认修改",
  "xch_01548": "确认新增",
  "xch_01549": "收款账户",
  "xch_01550": "确认修改该收款账户？",
  "xch_01551": "确认添加该收款账户？",
  "xch_01552": "即代表授权我平台向该账户执行资金划转操作。",
  "xch_01553": "收款账户一般会在1个工作日内审核通过。",
  "xch_01554": "修改成功",
  "xch_01555": "创建成功",
  "xch_01556": "修改失败，请重试",
  "xch_01557": "创建失败，请重试",
  "xch_01558": "请选择账户类型",
  "xch_01559": "账户类型",
  "xch_01560": "同名转账",
  "xch_01561": "非同名转账",
  "xch_01562": "账户名称",
  "xch_01563": "账户号码",
  "xch_01564": "SWIFT Code",
  "xch_01565": "开户银行",
  "xch_01566": "开户银行地址",
  "xch_01567": "请上传公司证书、双方合作协议",
  "xch_01568": "支持pdf、jpg、png等格式。",
  "xch_01569": "证明文件",
  "xch_01570": "发起提现",
  "xch_01571": "提现记录",
  "xch_01572": "收款账户列表",
  "xch_01573": "获取账户列表失败",
  "xch_01574": "获取账户列表失败，请重试",
  "xch_01575": "提现申请提交成功",
  "xch_01576": "提现申请失败",
  "xch_01577": "提现账户",
  "xch_01578": "暂无收款账户",
  "xch_01579": "立即添加",
  "xch_01580": "提现金额",
  "xch_01581": "手续费承担方式",
  "xch_01582": "交易附言",
  "xch_01892": "端到端标识号",
  "xch_01583": "提现可用时间",
  "xch_01584": "工作日 09:00 ~ 17:30",
  "xch_01585": "确认提现",
  "xch_01586": "请确认以下提现信息",
  "xch_01587": "进行中",
  "xch_01588": "提款失败",
  "xch_01589": "未找到提现钱包，请联系您的账户经理。",
  "xch_01590": "删除成功",
  "xch_01591": "删除失败",
  "xch_01592": "删除失败，请重试。",
  "xch_01593": "确认删除该收款账户？删除后将无法恢复，请谨慎操作",
  "xch_01594": "确认删除",
  "xch_01595": "到账时间",
  "xch_01596": "获取提现详情失败",
  "xch_01597": "获取提现详情失败，请重试",
  "xch_01598": "提现订单已创建",
  "xch_01599": "提现完成",
  "xch_01600": "提现后的 {0} 余额",
  "xch_01601": "提现前的 {0} 余额",
  "xch_01602": "交易状态",
  "xch_01603": "我们已经将您的资金提现至收款账户",
  "xch_01604": "我们正在处理您的提现金额",
  "xch_01605": "未找到提现详情",
  "xch_01606": "提现详情",
  "xch_01607": "付款凭证",
  "xch_01608": "客户详情",
  "xch_01609": "银行转账",
  "xch_01610": "柜台现金/刷卡交易",
  "xch_01611": "PayNow",
  "xch_01612": "NETS",
  "xch_01613": "授权人收款",
  "xch_01614": "交易记录",
  "xch_01615": "限额配置",
  "xch_01616": "最低限额",
  "xch_01617": "最大限制",
  "xch_01618": "最大值必须大于最小值",
  "xch_01619": "稳定币钱包地址",
  "xch_01620": "前置绑定您的收款银行账户，用于接收法币收款，确保资金结算安全、准确。",
  "xch_01621": "绑定您的数字资产钱包地址，用于接收区块链网络上的汇款，确保资金转移合法合规。",
  "xch_01622": "选择收款方式",
  "xch_01623": "稳定币钱包账户",
  "xch_01624": "币种（Token Symbol)",
  "xch_01625": "主网络（Network / Chain）",
  "xch_01626": "钱包地址（Wallet Address）",
  "xch_01627": "合约地址（Contract Address）",
  "xch_01628": "全球支付",
  "xch_01629": "档案ID",
  "xch_01630": "查询号",
  "xch_01631": "模板下载链接不存在",
  "xch_01632": "请先选择转账模式",
  "xch_01633": "确认批准",
  "xch_01634": "确认客户信息正确并批准审核？",
  "xch_01635": "确认拒绝",
  "xch_01636": "请说明拒绝理由：",
  "xch_01637": "是否确定将订单标记为确认收款？",
  "xch_01638": "选择业务类型",
  "xch_01639": "服务/货物贸易",
  "xch_01640": "POBO模式",
  "xch_01641": "您正在创建支持 POBO 模式的企业账户，用于服务/商品交易。请填写公司名称和法定代表人信息。",
  "xch_01642": "点击查看示例",
  "xch_01643": "法人信息",
  "xch_01644": "姓名",
  "xch_01645": "身份证号码",
  "xch_01646": "联系电话",
  "xch_01647": "身份证有效期",
  "xch_01648": "用于企业间货物或服务贸易的资金结算，例如出口收款、进口付款、跨境采购、委托加工、运输或技术服务费结算等。系统将基于贸易类型和付款用途，生成相应的合规报文与凭证。",
  "xch_01649": "适用于企业发薪或其他形式的对个人付款业务。系统将该企业识别为付款方主体，用于后续发薪、对账及合规申报。\n",
  "xch_01650": "生效日期",
  "xch_01651": "失效日期",
  "xch_01652": "POBO 开通状态",
  "xch_01653": "费用配置",
  "xch_01654": "POBO 开通失败，请联系运营人员",
  "xch_01655": "开通 POBO",
  "xch_01656": "缺少企业档案ID，无法创建POBO账户",
  "xch_01657": "更新企业信息失败",
  "xch_01658": "POBO 申请创建完成",
  "xch_01659": "永久",
  "xch_01660": "待收款人补充中文名",
  "xch_01661": "中文名称补充成功",
  "xch_01662": "补充中文名称",
  "xch_01663": "补充收款人中文名称",
  "xch_01664": "中文名称",
  "xch_01665": "请输入收件人的中文名称",
  "xch_01666": "请输入 2-10 个汉字",
  "xch_01667": "链接已复制到剪贴板",
  "xch_01668": "复制失败，请手动复制文字",
  "xch_01669": "复制 RFI 链接失败",
  "xch_01670": "复制 RFI 链接",
  "xch_01671": "获取订单详情失败，请稍后重试",
  "xch_01672": "编辑收款方信息",
  "xch_01673": "格式无效。必须为“是”或“否”。",
  "xch_01674": "护照号码",
  "xch_01675": "护照有效期",
  "xch_01676": "是",
  "xch_01677": "否",
  "xch_01678": "POBO模式的订单需要提交收款企业营业执照",
  "xch_01679": "完成时间",
  "xch_01680": "推荐码",
  "xch_01681": "联系信息",
  "xch_01682": "请输入有效的电子邮件地址",
  "xch_01683": "订单正在转账受理中",
  "xch_01684": "查看订单",
  "xch_01685": "全球收款账户",
  "xch_01686": "账户列表",
  "xch_01687": "创建账户",
  "xch_01688": "创建结果",
  "xch_01689": "文档中心",
  "xch_01690": "账户交易记录",
  "xch_01691": "即将上线",
  "xch_01692": "请选择地区和币种",
  "xch_01693": "请先选择地区",
  "xch_01694": "请选择币种",
  "xch_01695": "开通收款账户",
  "xch_01696": "选择开通的国家地区账户",
  "xch_01697": "重新选择",
  "xch_01698": "选择币种",
  "xch_01699": "账户ID不存在",
  "xch_01700": "账户信息加载失败",
  "xch_01701": "返回列表",
  "xch_01702": "缺少账户ID",
  "xch_01703": "全球收款账户详情",
  "xch_01704": "账户信息加载失败",
  "xch_01705": "收款人账户号码",
  "xch_01706": "收款银行",
  "xch_01707": "收款银行地址",
  "xch_01708": "收款银行 SWIFT CODE",
  "xch_01709": "收款人地址",
  "xch_01710": "汇款备注码",
  "xch_01711": "中间行信息",
  "xch_01712": "中间行 SWIFT CODE",
  "xch_01713": "跨境收款指引",
  "xch_01714": "帮助企业理解如何通过大账户进行跨境收款：包括银行信息填写方法、收款备注码使用方式、填写示例截图、常见错误示例、注意事项等，确保企业能成功汇款并被系统正确识别。",
  "xch_01715": "企业收款指引",
  "xch_01716": "查看指引",
  "xch_01717": "付款方名称",
  "xch_01718": "付款方账号",
  "xch_01719": "付款方银行",
  "xch_01720": "账户交易列表",
  "xch_01721": "已选择",
  "xch_01722": "银行位置",
  "xch_01723": "账户标识",
  "xch_01724": "获取账户列表失败",
  "xch_01725": "创建收款账户",
  "xch_01726": "企业发薪转账",
  "xch_01727": "企业发薪",
  "xch_01728": "平台接入所需的基础材料",
  "xch_01729": "待收到您的提交资料，我方将尽快完成审核并激活基础产品试用服务。此举旨在协助您通过实操充分了解产品功能，以期促进双方对接效率，从而加速整体接入进程。",
  "xch_01730": "提交基础材料",
  "xch_01731": "重新提交材料",
  "xch_01732": "Swift 代码不能为空。",
  "xch_01733": "Swift 代码错误，请填写正确的 Swift 代码",
  "xch_01734": "下载 CNY 模版",
  "xch_01735": "下载 USD 模版",
  "xch_01736": "全球支付转账",
  "xch_01737": "可以前往交易列表查看",
  "xch_01738": "下载 原币模式 模版",
  "xch_01739": "电商平台",
  "xch_01740": "店铺管理",
  "xch_01741": "店铺名称",
  "xch_01742": "店铺网址",
  "xch_01743": "店铺详情",
  "xch_01744": "创建店铺",
  "xch_01745": "店铺列表",
  "xch_01746": "店铺名称",
  "xch_01747": "店铺网址",
  "xch_01748": "店铺简介",
  "xch_01749": "店铺Logo",
  "xch_01750": "店铺横幅图",
  "xch_01751": "主题色",
  "xch_01752": "经营品类",
  "xch_01753": "联系邮箱",
  "xch_01754": "联系电话",
  "xch_01755": "所在国家",
  "xch_01756": "详细地址",
  "xch_01757": "营业执照号",
  "xch_01758": "ICP备案号",
  "xch_01759": "VAT 税号",
  "xch_01760": "出口备案号",
  "xch_01761": "商品名称",
  "xch_01762": "HS编码",
  "xch_01763": "商品品类",
  "xch_01764": "商品描述",
  "xch_01765": "商品图片",
  "xch_01766": "计量单位",
  "xch_01767": "单价",
  "xch_01768": "货币",
  "xch_01769": "原产地",
  "xch_01770": "销量",
  "xch_01771": "获取店铺详情失败",
  "xch_01772": "编辑店铺",
  "xch_01773": "订单总数",
  "xch_01774": "商品总数",
  "xch_01775": "成交额",
  "xch_01776": "统计更新时间",
  "xch_01777": "店铺配置",
  "xch_01778": "联系方式",
  "xch_01779": "合规信息",
  "xch_01780": "店铺详情",
  "xch_01781": "经营统计",
  "xch_01782": "商品列表",
  "xch_01783": "本次兑换方式",
  "xch_01784": "下载 简洁模式 模版",
}
